import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/components/layout.jsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const SEO = makeShortcode("SEO");
const Menu = makeShortcode("Menu");
const Battle = makeShortcode("Battle");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <SEO title="Expedition 33 Expert Glitchless DLC Superbosses" mdxType="SEO" />
    <h1 {...{
      "id": "clair-obscur-expedition-33-expert-glitchless-dlc-superbosses-route"
    }}>{`Clair Obscur: Expedition 33 Expert Glitchless DLC Superbosses Route`}</h1>
    <p>{`Goal of this category is to defeat Osquio and the 4 Endless Tower Superbosses as fast as possible. This uses Expert Glitchless Any% as a base. First 2 Acts are very similar, but this does pick up a few extra pictos.`}</p>
    <hr></hr>
    <h3 {...{
      "id": "notation"
    }}>{`Notation`}</h3>
    <p>{`For menus, I will sometimes have something in parenthesis. If it's (S1-3), it refers to the slot the Picto should be placed in. If it's a Playstation controller button, it's a button you should press to optimize the menu.`}</p>
    <p>{`For battles, there will sometimes be something like (1.1 QTE). This refers to the Quick Time Action you do when you use an Ability. A perfect is 1.2, a normal is 1.1, and a fail is 1.0. The number refers to the damage multiplier the skill gets from the QTE.`}</p>
    <p>{`Cutscene menu: you can open a menu right before you enter a cutscene transition, which will give you about 3s of menu time before the cutscene plays. You can use this to squeeze in menus and reduce wasted time. Menus will be labeled with which cutscenes they can be done during. Note that this seperates the menus, so if you're not doing cutscene menus you will want to combine them into one menu.`}</p>
    <hr></hr>
    <p>{`You can check the changelog at the bottom of the notes. This changelog will be restarted for this patch, so to check older stuff refer to the older patch notes.`}</p>
    <p>{`These are my personal notes for the category, the writing will reflect that. For the most part these notes will not say where to go or where things are, just what to do. I will be updating these as the route progresses, changes will be reflected in the changelog at the bottom of the notes.`}</p>
    <p>{`There will also be enemy data and maybe some other useful information at the bottom of the notes.`}</p>
    <p>{`If there's a time listed by a fight, it's my best time for it so far. It does not represent the average.`}</p>
    <h2 {...{
      "id": "prologue"
    }}>{`Prologue`}</h2>
    <p>{`Maelle Duel: Abandon Battle (Timing is soon as Gustave can act)`}</p>
    <h3 {...{
      "id": "harbor"
    }}>{`Harbor`}</h3>
    <ul>
      <li parentName="ul">{`Talk to Aprentices`}</li>
      <li parentName="ul">{`Talk to Maelle, skip Maelle duel`}</li>
      <li parentName="ul">{`Talk to Emma`}</li>
    </ul>
    <p>{`4 CS on Transition`}</p>
    <h2 {...{
      "id": "act-i"
    }}>{`Act I`}</h2>
    <h3 {...{
      "id": "spring-meadows"
    }}>{`Spring Meadows`}</h3>
    <Menu timing="Cutscene entering Lancelier or Portier battle" mdxType="Menu">
      <h5 {...{
        "id": "skills"
      }}>{`Skills`}</h5>
      <ul>
        <li parentName="ul">{`Gustave: Lumiere Assault Top-Right`}</li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "lancelier-122hp-6xp-50-010"
      }}>{`Lancelier 122HP 6XP $50 (0:10)`}</h4>
      <ul>
        <li parentName="ul">{`Shoot Weak Spot, Attack > Parry`}</li>
      </ul>
    </Battle>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "portier-450hp-008"
      }}>{`Portier 450HP (0:08)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`10XP, $75, Dodger + 0-2 Chroma Catalyst `}</p>
      </blockquote>
      <blockquote>
        <p parentName="blockquote">{`You can shoot 2 extra times with Gustave. If he crits the attack, you can then shoot twice with Lune and Immolation to kill.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-1"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Shoot weak spot, Attack`}</li>
        <li parentName="ul">{`Lune: Ice Lance`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`For the AoE attack, start mashing dodge as soon as his arms touch together. After 3 dodges, parry.`}</p>
      </blockquote>
      <p>{`Counter to kill.`}</p>
    </Battle>
    <p>{`Pick up `}<strong parentName="p">{`Critical Burn`}</strong>{`.`}<br parentName="p"></br>{`
`}{`First strike the Lanceram before the house.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "2-lancelier-240hp-019"
      }}>{`2 Lancelier 240HP (0:19)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`53XP, $144, Lanceram LV1`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Shoot weak spots, Attack`}</li>
        <li parentName="ul">{`Lune: Ice Lance`}</li>
      </ul>
      <p>{`Parry.`}</p>
      <h5 {...{
        "id": "turn-1-1"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Attack`}</li>
      </ul>
    </Battle>
    <p>{`You can jump up to the right side before the house, or take the path through the house.`}<br parentName="p"></br>{`
`}{`Pick up `}<strong parentName="p">{`Energy Tint Shard`}</strong>{`, `}<strong parentName="p">{`$360`}</strong>{` in house detour.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "3-volester-81hp-017"
      }}>{`3 Volester 81HP (0:17)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`43XP, $216, 0-2 Chroma Catalyst?`}<br parentName="p"></br>{`
`}{`Parry timing is on slowdown/freeze frames on both of their attacks`}</p>
      </blockquote>
      <p>{`Parry both attacks. Shoot last one to death. Requires 5AP.`}</p>
    </Battle>
    <Menu timing="Entering journal cutscene" mdxType="Menu">
      <h5 {...{
        "id": "weapon"
      }}>{`Weapon`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Lanceram`}</li>
      </ul>
      <h5 {...{
        "id": "pictos"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Gustav`}<ul parentName="li">
            <li parentName="ul">{`+Dodger`}</li>
            <li parentName="ul">{`+Critical Burn`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`Pick up `}<strong parentName="p">{`Dead Energy II`}</strong>{`. Afterwards, jump off to the left and menu.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "pictos-1"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Gustav`}<ul parentName="li">
            <li parentName="ul">{`+Dead Energy II`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`First strike the Abbest on your left.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "2-volester-1-abbest-009"
      }}>{`2 Volester, 1 Abbest (0:09)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`$216, 55XP`}<br parentName="p"></br>{`
`}{`If you missed XP after Portier, take the fight before Eveque instead. Strat for that fight is in the archive section of these notes.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-1"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Gustav:`}<ul parentName="li">
            <li parentName="ul">{`Shoot each Volester 3 times, don't hit weakness.`}</li>
            <li parentName="ul">{`Shoot Abbest weakness, skip.`}</li>
          </ul></li>
        <li parentName="ul">{`Lune: Ice Lance (1.1)`}</li>
      </ul>
    </Battle>
    <p>{`Go to Flag.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-attributes"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: +9 Might (9)`}</li>
        <li parentName="ul">{`Lune: +9 Might (9)`}</li>
      </ul>
      <h5 {...{
        "id": "learn-skills"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Marking Shot, Powerful (in that order)`}</li>
      </ul>
    </Menu>
    <Menu timing="Cutscene entering Eveque fight" mdxType="Menu">
      <h5 {...{
        "id": "weapon-1"
      }}>{`Weapon`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Lighterim`}</li>
      </ul>
      <p><em parentName="p">{`If missed, equip in Flying Waters`}</em></p>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "eveque-4524hp-204"
      }}>{`Eveque 4524HP (2:04)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`$862, Cleansing Tint, 5 Chroma Catalyst, 0-2 Recoat`}</p>
      </blockquote>
      <blockquote>
        <p parentName="blockquote">{`The chance of you getting the fast fight are much lower on this patch.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-1-2"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: (If Gustave target shoot 1 shield), Powerful`}</li>
        <li parentName="ul">{`Lune: Shoot off shields (last shield shoot weakpoint), Shoot till 3AP, Immolation`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Marking Shot`}</li>
        <li parentName="ul">{`Lune: Immolation`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Shoot till 2AP, Marking Shot`}</li>
        <li parentName="ul">{`Lune: Energising Tint Gustave`}</li>
      </ul>
      <p>{`Stop countering Eveque on this turn, until you do the Overcharge.`}<br parentName="p"></br>{`
`}{`You can kill one Abbest for AP generation & speeding up the backup. Killing both before Eveque will break the XP route.`}</p>
      <h5 {...{
        "id": "turn-4"
      }}>{`Turn 4`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Overcharge`}</li>
      </ul>
      <p>{`If not dead, shoot off shields and damage as best as you can.`}<br parentName="p"></br>{`
`}{`If it was no crit and Eveque is still healthy, don't counter it's attack so it starts charging up. You can then inflict a good chunk of damage by shooting the core again.`}</p>
    </Battle>
    <p><strong parentName="p">{`PICK UP EMPOWERING ATTACK`}</strong>{` before exiting Spring Meadows.`}</p>
    <h3 {...{
      "id": "continent"
    }}>{`Continent`}</h3>
    <p>{`Go to Camp before entering Flying Waters`}</p>
    <h3 {...{
      "id": "flying-waters"
    }}>{`Flying Waters`}</h3>
    <Menu timing="Cutscene at start of area or before entering Manor" mdxType="Menu">
      <h5 {...{
        "id": "pictos-2"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Gustave: `}<ul parentName="li">
            <li parentName="ul">{`Remove All`}</li>
            <li parentName="ul">{`+(S3) Empowering Attack`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`Pick up `}<strong parentName="p">{`$333`}</strong>{` along path.`}</p>
    <p>{`Take the detour to the right by the tunnel to spawn 3 Demineur and fight them.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "3-demineur-218hp-004"
      }}>{`3 Demineur 218HP (0:04)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`1180XP $399`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-2"
      }}>{`Turn 0`}</h5>
      <p>{`Shoot the 3 bombs`}</p>
    </Battle>
    <p>{`Go to Manor.`}</p>
    <Menu timing="Cutscene entering Maelle's room" mdxType="Menu">
      <h5 {...{
        "id": "pictos-3"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Maelle`}<ul parentName="li">
            <li parentName="ul">{`+Critical Burn`}</li>
            <li parentName="ul">{`+Dead Energy II`}</li>
            <li parentName="ul">{`+Dodger`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`Jump towards flag.`}</p>
    <Menu timing="When you land near flag" mdxType="Menu">
      <blockquote>
        <p parentName="blockquote">{`This menu is unnecessary, it was used when you had to wait for dialogue to end to menu. However, I'm used to it so I'm leaving this in for muscle memory.`}</p>
      </blockquote>
      <h5 {...{
        "id": "skills-1"
      }}>{`Skills`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Top-Right slot equip Spark`}</li>
      </ul>
    </Menu>
    <p>{`Interact with flag.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-attributes-1"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: +1 Might (10), +5 Agility (5)`}</li>
        <li parentName="ul">{`Maelle: +15 Might (15)`}</li>
      </ul>
      <h5 {...{
        "id": "learn-skills-1"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Swift Stride`}</li>
        <li parentName="ul">{`Lune: +Thunderfall, +Wildfire, +Electrify`}</li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "the-curator-hp-024"
      }}>{`The Curator ?HP (0:24)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`720XP, $376`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-1-3"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Powerful`}</li>
        <li parentName="ul">{`Maelle: Offensive Shift`}</li>
        <li parentName="ul">{`Lune: Skip`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-1"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Marking Shot`}</li>
        <li parentName="ul">{`Maelle: Percee`}</li>
      </ul>
    </Battle>
    <p>{`Talk to Noco and fight him.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "noco-1670hp-022"
      }}>{`Noco 1670HP (0:22)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`486XP $200 `}</p>
      </blockquote>
      <p>{`Offensive Shift > Parry > 1 Shot, Spark`}</p>
    </Battle>
    <p>{`Buy `}<strong parentName="p">{`Exposing Attack ($3600)`}</strong>{`. After Noco continue straight.`}<br parentName="p"></br>{`
`}{`Fight the `}<strong parentName="p">{`Bruler`}</strong>{` that jumps down at you before the tunnel`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "demineur-bruler-luster-014"
      }}>{`Demineur, Bruler, Luster (0:14)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`1412XP, $466, Bruleram LV3`}<br parentName="p"></br>{`
`}{`You get ~72 more EXP here by killing Bruler first.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-3"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Shoot Mine, Marking Shot Bruler`}</li>
        <li parentName="ul">{`Lune: Skip`}</li>
        <li parentName="ul">{`Maelle:`}<ul parentName="li">
            <li parentName="ul">{`Shoot Bruler weakspot (kill)`}</li>
            <li parentName="ul">{`Shoot Demineur head once, anywhere once`}</li>
            <li parentName="ul">{`Shoot rest of AP at Luster weakspot, if he lives Attack`}</li>
          </ul></li>
      </ul>
    </Battle>
    <Menu timing="Coral Cave flag" mdxType="Menu">
      <h5 {...{
        "id": "upgrade-attributes-2"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: +6 Might (16)`}</li>
        <li parentName="ul">{`Maelle: +2 Might (17), +1 Agility (1)`}</li>
        <li parentName="ul">{`Lune: +8 Might (17), +4 Agility (4)`}</li>
      </ul>
    </Menu>
    <Menu timing="Anytime before Goblu" mdxType="Menu">
      <h5 {...{
        "id": "weapon-2"
      }}>{`Weapon`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Bruleram`}</li>
      </ul>
      <h5 {...{
        "id": "pictos-4"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Lune:`}<ul parentName="li">
            <li parentName="ul">{`+Exposing Attack`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Lune`}<ul parentName="li">
            <li parentName="ul">{`+Critical Burn`}</li>
          </ul></li>
        <li parentName="ul">{`Gustav`}<ul parentName="li">
            <li parentName="ul">{`+Critical Burn`}</li>
          </ul></li>
      </ul>
    </Menu>
    <Menu timing="Goblu cutscene" mdxType="Menu">
      <h5 {...{
        "id": "lumina-1"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Gustave: +Dodger`}</li>
        <li parentName="ul">{`Lune: +Dodger`}</li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "goblu-22815hp-137"
      }}>{`Goblu 22815HP (1:37)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`3240XP, $1330, 0-2? Recoat`}</p>
      </blockquote>
      <blockquote>
        <p parentName="blockquote">{`The main fight now is the 5T, as getting a fast fight is near impossible now.`}<br parentName="p"></br>{`
`}{`I'd only go for it if you got both Maelle counter and Percee crit.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-1-4"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Wildfire`}</li>
        <li parentName="ul">{`Gustav: Powerful`}</li>
        <li parentName="ul">{`Maelle: Swift Stride`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-2"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Attack`}</li>
        <li parentName="ul">{`Gustav: Marking Shot`}</li>
        <li parentName="ul">{`Maelle: Percee`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-1"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Wildfire`}</li>
        <li parentName="ul">{`Gustav: Powerful`}</li>
        <li parentName="ul">{`Maelle: Offensive Shift`}</li>
      </ul>
      <h5 {...{
        "id": "turn-4-1"
      }}>{`Turn 4`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Wildfire`}</li>
        <li parentName="ul">{`Gustav: Overcharge`}</li>
        <li parentName="ul">{`Maelle: Can shoot till 3ATB, Swift Stride`}</li>
      </ul>
      <h5 {...{
        "id": "turn-5"
      }}>{`Turn 5`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Attack`}</li>
        <li parentName="ul">{`Gustav: Marking Shot`}</li>
        <li parentName="ul">{`Maelle: Percee`}</li>
      </ul>
      <p>{`If still alive, do Turn 5 again.`}</p>
      <p>{`If you got REALLY good damage, replace turns 3 & 4 with:`}</p>
      <ul>
        <li parentName="ul">{`Lune: Immolation`}</li>
        <li parentName="ul">{`Gustav: Overcharge`}</li>
        <li parentName="ul">{`Maelle: Can shoot till 3ATB, Swift Stride`}</li>
      </ul>
    </Battle>
    <h3 {...{
      "id": "camp"
    }}>{`Camp`}</h3>
    <p>{`Talk to Curator.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-weapons"
      }}>{`Upgrade Weapons`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Bruleram +1 (4)`}</li>
        <li parentName="ul">{`Lune: Lighterim +2 (3)`}</li>
      </ul>
    </Menu>
    <p>{`Go to sleep.`}</p>
    <h3 {...{
      "id": "ancient-sanctuary"
    }}>{`Ancient Sanctuary`}</h3>
    <p>{`Go fight the Petank`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "petank"
      }}>{`Petank`}</h4>
      <blockquote>
        <p parentName="blockquote">{`$3860, 5 Polished, 5 Lumina, 1 Recoat`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-1-5"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Immolation`}</li>
        <li parentName="ul">{`Gustave: Powerful`}</li>
        <li parentName="ul">{`Maelle: Swift Stride (Full QTE)`}</li>
      </ul>
      <p>{`Dodge his attack.`}</p>
      <h5 {...{
        "id": "turn-2-3"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Attack`}</li>
        <li parentName="ul">{`Gustave: Marking Shot`}</li>
        <li parentName="ul">{`Maelle: 3 Shots, Percee`}</li>
        <li parentName="ul"><em parentName="li">{`If still alive`}</em>{` Lune: Ice Lance`}</li>
      </ul>
    </Menu>
    <p><strong parentName="p">{`PICK UP BURNING MARK`}</strong>{`.`}</p>
    <Menu timing="Cutscene entering Robust Sakapatate fight" mdxType="Menu">
      <h5 {...{
        "id": "skills-2"
      }}>{`Skills`}</h5>
      <ul>
        <li parentName="ul">{`Lune: -Thunderfall, -Electrify`}</li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "robust-sakapatate-5792hp-039"
      }}>{`Robust Sakapatate 5792HP (0:39)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`1824XP, $435, Sakaram Lv.4`}</p>
      </blockquote>
      <blockquote>
        <ul parentName="blockquote">
          <li parentName="ul">{`Swings with it's partner: 1 Hit AoE`}</li>
          <li parentName="ul">{`Slams it's shield: 1 Hit AoE, raises Shield and will counter next time its hit.`}</li>
          <li parentName="ul">{`Shield counter: 1 hit AoE, need to dodge sooner than Slams it's shield.`}</li>
          <li parentName="ul">{`Clunky Combo: 2 hit, jump, 1 hit. Has easy audio cue`}</li>
        </ul>
      </blockquote>
      <p>{`Parry his shield attack (prevents him countering later). You can dodge everything else.`}</p>
      <h5 {...{
        "id": "turn-1-6"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Immolation (Fail QTE)`}</li>
        <li parentName="ul">{`Gustav: Skip`}</li>
        <li parentName="ul">{`Maelle: Swift Stride (Fail QTE)`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-4"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Attack`}</li>
        <li parentName="ul">{`Gustav: Marking Shot`}</li>
        <li parentName="ul">{`Maelle: Percee`}</li>
      </ul>
    </Battle>
    <blockquote>
      <p parentName="blockquote">{`If you missed any Maelle XP, you will need to do the old version of Ultimate Sakapatate with Percee instead of Rain of Fire`}</p>
    </blockquote>
    <p>{`Go to flag.`}</p>
    <Menu timing="Flag before Ultimate Sakapatate" mdxType="Menu">
      <h5 {...{
        "id": "upgrade-attributes-3"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: +9 Might (26)`}</li>
      </ul>
      <h5 {...{
        "id": "learn-skills-2"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Degagement, Rain of Fire`}</li>
      </ul>
    </Menu>
    <Menu timing="Cutscene menu entering Ultimate Sakapatate" mdxType="Menu">
      <h5 {...{
        "id": "weapons"
      }}>{`Weapons`}</h5>
      <ul>
        <li parentName="ul">{`Gustave: Sakaram`}</li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "ultimate-sakapatate-28236hp-144"
      }}>{`Ultimate Sakapatate 28236HP (1:44)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`8100XP, $1930, Breaker + 3 Polished Catalyst + 0-2 Recoats`}</p>
      </blockquote>
      <blockquote>
        <ul parentName="blockquote">
          <li parentName="ul">{`Slams the ground: 1 hit AoE, naturally parry timing.`}</li>
          <li parentName="ul">{`Fires it's Cannons: look for Fire on it's cannons as indicator, parry when you see it.`}</li>
          <li parentName="ul">{`Slams it's shield: 1 hit single target.`}</li>
          <li parentName="ul">{`Combo: 2 hits into jump, dodge the first 2 no point in parrying.`}</li>
          <li parentName="ul">{`Launches weird elecric things: 3 hit single target: Parry once they're top of their arc / flying down.`}</li>
        </ul>
      </blockquote>
      <h5 {...{
        "id": "turn-1-7"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Immolation`}</li>
        <li parentName="ul">{`Gustav: Powerful`}</li>
        <li parentName="ul">{`Maelle: Swift Stride`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-5"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Shoot once, then shoot shoulder 3 times to break it. Attack.`}</li>
        <li parentName="ul">{`Gustav: Marking Shot`}</li>
        <li parentName="ul">{`Maelle: Rain of Fire`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-2"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Attack`}</li>
        <li parentName="ul">{`Gustav: Energy Tint Maelle / Marking Shot / Overcharge / Skip`}</li>
        <li parentName="ul">{`Maelle: Rain of Fire`}</li>
      </ul>
      <p>{`Should die to burns, but if not finish T4 with whatever.`}</p>
    </Battle>
    <p>{`Can Chroma Elixer anytime before entering Tournament.`}</p>
    <h3 {...{
      "id": "gestral-village"
    }}>{`Gestral Village`}</h3>
    <h3 {...{
      "id": "tournament"
    }}>{`Tournament`}</h3>
    <p>{`Pattern for first 3 fights: Parry, `}<strong parentName="p">{`Degagement`}</strong>{`, Parry, Rain of Fire`}<br parentName="p"></br>{`
`}{`If you crit the 1st parry, Swift Stride instead. Can kill with Percee if they tank the 2nd counter.`}</p>
    <p>{`Rewards for each: 2026XP, $366`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "bertrand-big-hands-022"
      }}>{`Bertrand Big Hands (0:22)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`Swinging Right Hook x2, Left Uppercut (parry end of windup)`}</p>
      </blockquote>
      <h4 {...{
        "id": "dominique-giant-feet-027"
      }}>{`Dominique Giant Feet (0:27)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`Two-handed Ground Pound x2, Right Handed Ground Pound (Parry indicator is his elbow pointing up)`}</p>
      </blockquote>
      <h4 {...{
        "id": "matthieu-the-colossus-023"
      }}>{`Matthieu the Colossus (0:23)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`Left Hook x2, Right `}<strong parentName="p">{`Feint`}</strong>{` into Left Uppercut (Parry as he swings)`}</p>
      </blockquote>
      <h4 {...{
        "id": "sciel-3211hp-024"
      }}>{`Sciel 3211HP (0:24)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`You can add shots here to help odds of getting fast fight. Can make a difference if only 1 RoF crit.`}</p>
      </blockquote>
      <p>{`Parry, Rain of Fire, Parry`}</p>
      <blockquote>
        <ul parentName="blockquote">
          <li parentName="ul">{`Sealed Fate: 3 Hit`}</li>
          <li parentName="ul">{`Twilight Slash: 1 Hit`}</li>
          <li parentName="ul">{`Marking Card: 2 hit projectile, Parry as circle closes.`}</li>
        </ul>
      </blockquote>
      <p>{`You need to win vs Sciel for this route.`}</p>
    </Battle>
    <p>{`Talk to Golgra. Then go talk to Jujubree (Merchant).`}</p>
    <Menu mdxType="Menu">
      <blockquote>
        <p parentName="blockquote">{`If you got Polished drops, still want to buy all here.`}</p>
      </blockquote>
      <h5 {...{
        "id": "buy"
      }}>{`Buy`}</h5>
      <ul>
        <li parentName="ul">{`2 Polished Chroma Catalyst (10)`}</li>
        <li parentName="ul">{`Critical Moment`}</li>
      </ul>
    </Menu>
    <h4 {...{
      "id": "camp-1"
    }}>{`Camp`}</h4>
    <p>{`Sleep. Go to Esquie's Nest.`}</p>
    <h3 {...{
      "id": "esquies-nest"
    }}>{`Esquie's Nest`}</h3>
    <Menu timing="Flag at entrance" mdxType="Menu">
      <h5 {...{
        "id": "upgrade-attributes-4"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: +12 Agility (17)`}</li>
        <li parentName="ul">{`Maelle: +9 Might (35)`}</li>
        <li parentName="ul">{`Sciel: +44 Might (44), +1 Agility (1)`}</li>
        <li parentName="ul">{`Lune: +15 Might (29)`}</li>
      </ul>
      <h5 {...{
        "id": "learn-skills-3"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
        <li parentName="ul">{`Sciel: `}<strong parentName="li">{`Phantom Blade`}</strong>{`, Intervention, Equip Intervention to Top Left slot`}</li>
      </ul>
    </Menu>
    <Menu timing="Cutscene with Gestral guard" mdxType="Menu">
      <h5 {...{
        "id": "weapons-1"
      }}>{`Weapons`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Medalum`}</li>
      </ul>
    </Menu>
    <Menu timing="Cutscene meeting Esquie" mdxType="Menu">
      <h5 {...{
        "id": "pictos-5"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Gustave:`}<ul parentName="li">
            <li parentName="ul">{`+Critical Moment`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina-2"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Sciel:`}<ul parentName="li">
            <li parentName="ul">{`+Dodger`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`If you didn't get the Weapons and Critical Moment equipped, do so before Francois fight.`}<br parentName="p"></br>{`
`}{`You can cutscene menu entering Francois fight for anything you missed earlier.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "francois-9652hp-018"
      }}>{`Francois 9652HP (0:18)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`2228XP, $392, 345SPD, Augmented First Strike + 0-2 Polished Chroma Catalyst`}</p>
      </blockquote>
      <p>{`Dodge his attacks, use rhythm like Eveque spells`}</p>
      <h5 {...{
        "id": "turn-1-8"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Marking Shot`}</li>
        <li parentName="ul">{`Lune: Attack`}</li>
        <li parentName="ul">{`Maelle: Shoot 3 times, Percee`}</li>
        <li parentName="ul">{`Gustave: Attack if not dead`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`Better to shoot with Maelle because you don't have to move your aim at all.`}</p>
      </blockquote>
    </Battle>
    <p>{`Backtrack to Esquie.`}</p>
    <Menu timing="Cutscene talking to Esquie" mdxType="Menu">
      <h5 {...{
        "id": "pictos-6"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Sciel:`}<ul parentName="li">
            <li parentName="ul">{`+Breaker`}</li>
            <li parentName="ul">{`+Augmented First Strike`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`After talking to Esquie, run to flag by Francois and fast travel to entrance. Exit to Continent.`}</p>
    <h3 {...{
      "id": "the-continent"
    }}>{`The Continent`}</h3>
    <p>{`Mount Esquie and Camp.`}</p>
    <h4 {...{
      "id": "camp-2"
    }}>{`Camp`}</h4>
    <p>{`Talk to Curator`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-weapons-1"
      }}>{`Upgrade Weapons`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Lighterim +4/5 (8/9)`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`If you get to Lighterim 9, skip the Curator after Dualliste.`}</p>
      </blockquote>
    </Menu>
    <h3 {...{
      "id": "the-continent-1"
    }}>{`The Continent`}</h3>
    <p>{`Pick up `}<strong parentName="p">{`Energising Start I`}</strong>{` on beach west of `}<strong parentName="p">{`Stone Wave Cliffs`}</strong><br parentName="p"></br>{`
`}{`Pick up `}<strong parentName="p">{`$1305`}</strong>{` after breaking the rocks to Stone Wave Cliffs`}</p>
    <h3 {...{
      "id": "stone-wave-cliffs"
    }}>{`Stone Wave Cliffs`}</h3>
    <Menu timing="Cutscene at start of area" mdxType="Menu">
      <h5 {...{
        "id": "pictos-7"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Sciel:`}<ul parentName="li">
            <li parentName="ul">{`+Energising Start I`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`Pick up `}<strong parentName="p">{`$790`}</strong>{` on the left before the 1st flag.`}</p>
    <p><strong parentName="p">{`Go break the paint cage and get Delaram`}</strong>{`.`}</p>
    <p>{`Pick up `}<strong parentName="p">{`First Strike`}</strong>{`. Menu on the jump down.`}</p>
    <Menu timing="After First Strike, before Rocher" mdxType="Menu">
      <h5 {...{
        "id": "pictos-8"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Gustave:`}<ul parentName="li">
            <li parentName="ul">{`+First Strike`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`First Strike the Rocher after the Paintress Shrine`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "rocher-011"
      }}>{`Rocher (0:11)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`1575XP, $316`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-4"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Gustave: Marking Shot`}</li>
        <li parentName="ul">{`Lune: Wildfire (Fail QTE)`}</li>
        <li parentName="ul">{`Maelle: Percee`}</li>
      </ul>
    </Menu>
    <p>{`Pick up `}<strong parentName="p">{`$790`}</strong>{` after Farm flag.`}</p>
    <Menu timing="Before Lampmaster" mdxType="Menu">
      <h5 {...{
        "id": "formation"
      }}>{`Formation`}</h5>
      <ul>
        <li parentName="ul">{`-Maelle, +Sciel`}</li>
      </ul>
      <h5 {...{
        "id": "pictos-9"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Lune:`}<ul parentName="li">
            <li parentName="ul">{`+Critical Moment`}</li>
            <li parentName="ul">{`+First Strike`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina-3"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Gustav:`}<ul parentName="li">
            <li parentName="ul">{`-Critical Burn`}</li>
            <li parentName="ul">{`+Exposing Attack`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`Pick up `}<strong parentName="p">{`Colour of Lumina`}</strong>{` after Farm before handholds, on the left.`}<br parentName="p"></br>{`
`}{`Pick up `}<strong parentName="p">{`Colour of Lumina`}</strong>{` before last grapple up.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "lampmaster-42677hp-148"
      }}>{`Lampmaster 42677HP (1:48)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`18900XP, $3160, 3 Polished Chroma Catalyst`}<br parentName="p"></br>{`
`}{`Need > 310 speed to outspeed him T2. 312 confirmed working.`}</p>
      </blockquote>
      <blockquote>
        <ul parentName="blockquote">
          <li parentName="ul">{`Switches off lights and attacks: 4 Lamps launch projectiles. Parry when lamps turn off.`}</li>
          <li parentName="ul">{`Jumps: Parry on landing.`}</li>
          <li parentName="ul">{`Power of its lamps: 1 Dark Attack, visual/audio pre attack cue?`}</li>
          <li parentName="ul">{`Tries to blind: 3 Physical, first swipe is later than it looks.`}</li>
          <li parentName="ul">{`Dark explosion: jumps and hits 1 on landing.`}</li>
        </ul>
      </blockquote>
      <p><strong parentName="p">{`Bonus Strats`}</strong><br parentName="p"></br>{`
`}{`After his first attack, you can do the following if you generated enough AP from dodges/parries.`}<br parentName="p"></br>{`
`}{`+2 Sciel AP: Skip the Tint on Sciel`}<br parentName="p"></br>{`
`}{`+3 Lune AP: Lune Ice Lance, Gustave Powerful, Sciel Tint Lune. Next turn, Lightning Dance, Gustave Tint Lune, Sciel Attack. Continue from Turn 3. If you do enough damage that you end phase 1 with Lightning Dance, you can Intervention > Wildfire early.`}</p>
      <p>{`In phase 1, you need to counter 3 or 4 attacks.`}<br parentName="p"></br>{`
`}{`You need 4602 extra damage with normal strat, 5551 with bonus strat. Add 206 if no Immolation crit.`}<br parentName="p"></br>{`
`}{`With Lighterim 9, it's 536/1587. `}</p>
      <h5 {...{
        "id": "turn-0-5"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Immolation`}</li>
      </ul>
      <h5 {...{
        "id": "turn-1-9"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Ice Lance`}</li>
        <li parentName="ul">{`Gustav: Tint Sciel`}</li>
        <li parentName="ul">{`Sciel: Intervention Lune`}</li>
        <li parentName="ul">{`Lune: Attack`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-6"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Powerful`}</li>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
      </ul>
      <p>{`Enter phase 2.`}</p>
      <blockquote>
        <ul parentName="blockquote">
          <li parentName="ul">{`Flying Combo: 4 hits, parry bit after audio cue`}</li>
          <li parentName="ul">{`Attacks with each arm: 4 hits, parry on audio cue?`}</li>
          <li parentName="ul">{`Vast ball of light: Jump, easy timing`}</li>
          <li parentName="ul">{`Sword of light: 1 hit, parry during it's swing at you`}</li>
        </ul>
      </blockquote>
      <p>{`You can dodge both moves, perfect dodge the Sword.`}</p>
      <h5 {...{
        "id": "turn-21"
      }}>{`Turn 2.1`}</h5>
      <ul>
        <li parentName="ul">{`Sciel: Tint Lune`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-3"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Gustave: Attack`}</li>
        <li parentName="ul">{`Lune: Wildfire`}</li>
        <li parentName="ul">{`Sciel: Intervention Lune`}</li>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
      </ul>
    </Battle>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "white-haired-man-049"
      }}>{`White-Haired Man (0:49)`}</h4>
      <p>{`Skip turn x4`}</p>
    </Battle>
    <h2 {...{
      "id": "act-ii"
    }}>{`Act II`}</h2>
    <h3 {...{
      "id": "camp-3"
    }}>{`Camp`}</h3>
    <p>{`Go to flag.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-attributes-5"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Lune: +9 Agility (13)`}</li>
        <li parentName="ul">{`Verso: +32 Might (32), +10 Agility (10)`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`The order for Verso's skills here matters.`}</p>
      </blockquote>
      <h5 {...{
        "id": "learn-skills-4"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Marking Shot, Quick Strike, Berserk Slash, Defiant Strike, Powerful`}</li>
        <li parentName="ul">{`Verso: Equip Berserk Slash Left-Middle, Equip Powerful Left-Bottom.`}</li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "continent-1"
    }}>{`Continent`}</h3>
    <Menu timing="Before entering Forgotten Battlefield" mdxType="Menu">
      <h5 {...{
        "id": "weapon-3"
      }}>{`Weapon`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Delaram`}</li>
      </ul>
      <h5 {...{
        "id": "pictos-10"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Verso`}<ul parentName="li">
            <li parentName="ul">{`+At Death's Door`}</li>
            <li parentName="ul">{`+First Strike`}</li>
          </ul></li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "forgotten-battlefield"
    }}>{`Forgotten Battlefield`}</h3>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "chalier-9724hp-024"
      }}>{`Chalier 9724HP (0:24)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`4134XP (NB), $593, 0-2 Polished Chroma Catalyst`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-1-10"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Dodge 1st attack`}</li>
        <li parentName="ul">{`Verso: Defiant Strike`}</li>
        <li parentName="ul">{`Let Verso die to Gradient`}</li>
        <li parentName="ul">{`Lune: Skip`}</li>
        <li parentName="ul">{`Maelle: Percee (1.1)`}</li>
      </ul>
    </Battle>
    <p>{`Buy `}<strong parentName="p">{`Inverted Affinity`}</strong>{` from Merchant ($11280).`}</p>
    <Menu timing="Jump down from Merchant" mdxType="Menu">
      <h5 {...{
        "id": "pictos-11"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`+Inverted Affinity > Empowering Attack`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina-4"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`-Exposing Attack`}</li>
            <li parentName="ul">{`+Critical Burn`}</li>
            <li parentName="ul">{`+Critical Moment`}</li>
            <li parentName="ul">{`+Dead Energy II`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "formation-1"
      }}>{`Formation`}</h5>
      <ul>
        <li parentName="ul">{`-Maelle, +Sciel`}</li>
      </ul>
    </Menu>
    <Menu timing="Cutscene entering Dualliste" mdxType="Menu">
      <h5 {...{
        "id": "lumina-5"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Lune: -Dodger`}</li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "dualliste-71106hp-200"
      }}>{`Dualliste 71106HP (2:00)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`33072XP, $3950, Dualiso + Combo Attack I + 3 Polished Chroma Catalyst + 0-1 Recoat?`}<br parentName="p"></br>{`
`}{`Threshold between him getting 2 attacks before you is somewhere between 328 and 318 speed.`}</p>
      </blockquote>
      <p>{`You can dodge all moves. Verso can parry to generate AP, no counter damage is needed.`}</p>
      <h5 {...{
        "id": "turn-0-6"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Berserk Slash`}</li>
      </ul>
      <h5 {...{
        "id": "turn-1-11"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Tint Verso / Nothing`}</li>
        <li parentName="ul">{`Verso: Berserk Slash`}</li>
        <li parentName="ul">{`Sciel: Attack`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-7"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Tint Verso / Nothing`}</li>
        <li parentName="ul">{`Verso: Berserk Slash / Defiant Strike`}</li>
      </ul>
      <p>{`Phase change.`}</p>
      <h5 {...{
        "id": "turn-21-1"
      }}>{`Turn 2.1`}</h5>
      <ul>
        <li parentName="ul">{`Sciel: Intervention Verso`}</li>
        <li parentName="ul">{`Verso: Berserk Slash`}</li>
      </ul>
      <p>{`Parry + Dodge AoE for AP generation.`}</p>
      <h5 {...{
        "id": "turn-3-4"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Attack / Skip if very good damage.`}</li>
        <li parentName="ul">{`Verso: Berserk Slash`}</li>
        <li parentName="ul">{`Sciel: Intervention Verso`}</li>
        <li parentName="ul">{`Verso: Berserk Slash`}</li>
      </ul>
    </Battle>
    <Menu timing="Gustave's funeral cutscene" mdxType="Menu">
      <h5 {...{
        "id": "pictos-12"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Lune: +Combo Attack`}</li>
      </ul>
      <h5 {...{
        "id": "lumina-6"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Sciel:`}<ul parentName="li">
            <li parentName="ul">{`(R3) -Dodger`}</li>
          </ul></li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "camp-4"
    }}>{`Camp`}</h3>
    <blockquote>
      <p parentName="blockquote">{`If you have Lighterim 9, just go straight to sleep.`}</p>
    </blockquote>
    <p>{`Go to Curator`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-weapons-2"
      }}>{`Upgrade Weapons`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Lighterim +1 (9)`}</li>
        <li parentName="ul">{`Sciel: Scielson +1 (6)`}</li>
      </ul>
    </Menu>
    <p>{`Option 2 to sleep.`}</p>
    <h3 {...{
      "id": "continent-2"
    }}>{`Continent`}</h3>
    <p>{`First Strike group before Monoco Station`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "demineur-troubador-gault-015"
      }}>{`Demineur, Troubador, Gault (0:15)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`6890XP (NB), $988, Troubadim LV8 + Gaulteram LV8 + 0-1? Recoat`}</p>
      </blockquote>
      <blockquote>
        <p parentName="blockquote">{`If Scielson LV5, have Lune or Verso shoot the Gault once.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-7"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Wildfire (Fail QTE)`}</li>
        <li parentName="ul">{`Verso: `}<ul parentName="li">
            <li parentName="ul">{`Shoot Mine then shoot Demineur 2 times.`}</li>
            <li parentName="ul">{`Defiant Strike Troubador`}</li>
          </ul></li>
        <li parentName="ul">{`Sciel: Phantom Blade Gault`}</li>
      </ul>
    </Battle>
    <Menu timing="Anytime before Monoco fight" mdxType="Menu">
      <h5 {...{
        "id": "weapon-4"
      }}>{`Weapon`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Dualiso`}</li>
      </ul>
      <h5 {...{
        "id": "pictos-13"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`+Combo Attack > At Death's Door (Swap)`}</li>
            <li parentName="ul">{`+Critical Moment > First Strike (Swap)`}</li>
            <li parentName="ul">{`+Exposing Attack > Inverted Affinity (Swap)`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina-7"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Lune:`}<ul parentName="li">
            <li parentName="ul">{`+Critical Moment`}</li>
          </ul></li>
        <li parentName="ul">{`Sciel:`}<ul parentName="li">
            <li parentName="ul">{`+First Strike`}</li>
          </ul></li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "monoco-station"
    }}>{`Monoco Station`}</h3>
    <Menu timing="Cutscene entering Monoco fight" mdxType="Menu">
      <h5 {...{
        "id": "lumina-8"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Verso: `}<ul parentName="li">
            <li parentName="ul">{`-Critical Burn`}</li>
            <li parentName="ul">{`-Dodger`}</li>
            <li parentName="ul">{`-Dead Energy II`}</li>
          </ul></li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "monoco-111599hp-030"
      }}>{`Monoco 111599HP (0:30)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`54000XP, $4360, 3 Polished Chroma Catalyst + 0-1 Recoat. Speed between 346-349`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-8"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Immolation `}</li>
        <li parentName="ul">{`Sciel: Energy Tint Lune`}</li>
      </ul>
      <p>{`Dodge his attack.`}</p>
      <h5 {...{
        "id": "turn-1-12"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Attack > Powerful`}</li>
        <li parentName="ul">{`Lune: Ice Lance`}</li>
        <li parentName="ul">{`Sciel: Intervention Lune`}</li>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
      </ul>
    </Battle>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "stalact-51507hp-048"
      }}>{`Stalact 51507HP (0:48)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`21600XP, $1744, Polished Chroma Catalyst + 0-1 Recoat`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-9"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Ice Lance (Fail QTE)`}</li>
        <li parentName="ul">{`Sciel: Intervention Lune`}</li>
        <li parentName="ul">{`Lune: Gradient > Lightning Dance`}</li>
      </ul>
    </Battle>
    <h3 {...{
      "id": "old-lumiere"
    }}>{`Old Lumiere`}</h3>
    <Menu timing="Jump down at start" mdxType="Menu">
      <h5 {...{
        "id": "pictos-14"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Lune`}<ul parentName="li">
            <li parentName="ul">{`+Energising Start I > At Death's Door (No Swap)`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina-9"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Lune: `}<ul parentName="li">
            <li parentName="ul">{`(R3) +At Death's Door`}</li>
          </ul></li>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`+At Death's Door`}</li>
            <li parentName="ul">{`(R3) +Inverted Affinity`}</li>
            <li parentName="ul">{`+First Strike`}</li>
          </ul></li>
        <li parentName="ul">{`Maelle: `}<ul parentName="li">
            <li parentName="ul">{`+Inverted Affinity`}</li>
            <li parentName="ul">{`+First Strike`}</li>
          </ul></li>
        <li parentName="ul">{`Monoco:`}<ul parentName="li">
            <li parentName="ul">{`+First Strike`}</li>
          </ul></li>
        <li parentName="ul">{`Sciel:`}<ul parentName="li">
            <li parentName="ul">{`+Inverted Affinity`}</li>
            <li parentName="ul">{`+Energising Start I`}</li>
          </ul></li>
      </ul>
    </Menu>
    <Menu mdxType="Menu">
      <p>{`Talk to flag.`}</p>
      <h5 {...{
        "id": "upgrade-attributes-6"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Recoat, +19 Might, +32 Agility, +5 Defense, +4 Luck`}</li>
        <li parentName="ul">{`Verso: +18 Agility (28)`}</li>
        <li parentName="ul">{`Maelle: +21 Might (53)`}</li>
        <li parentName="ul">{`Monoco: +78 Agility (78)`}</li>
        <li parentName="ul">{`Sciel: +12 Might (56)`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`Depending on Mask Keeper version, you might want to give Sciel +3 Luck here too.`}</p>
      </blockquote>
      <h5 {...{
        "id": "learn-skills-5"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Lune: +Mayhem, +Elemental Trick`}</li>
        <li parentName="ul">{`Lune: Equip Elemental Trick Left-Top`}</li>
        <li parentName="ul">{`Verso: +Perfect Recovery, +Leadership`}</li>
        <li parentName="ul">{`Verso: Equip Leadership Left-Top, Perfect Recovery Right-Top`}</li>
      </ul>
    </Menu>
    <Menu timing="Any cutscene menus." mdxType="Menu">
      <h5 {...{
        "id": "pictos-15"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Monoco:`}<ul parentName="li">
            <li parentName="ul">{`+Augmented First Strike`}</li>
          </ul></li>
        <li parentName="ul">{`Sciel: `}<ul parentName="li">
            <li parentName="ul">{`Remove All`}</li>
          </ul></li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "chevaliers-011"
      }}>{`Chevaliers (0:11)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`13662XP, $998, Battlum LV10 + 0-2 Polished Chroma Catalyst`}<br parentName="p"></br>{`
`}{`Verso outspeeds at 522 speed, 521 might work.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-10"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Rain of Fire (Perfect QTEs)`}</li>
        <li parentName="ul">{`Verso: Berserk Slash right Chevalier. If still alive, Attack.`}</li>
      </ul>
    </Battle>
    <Menu timing="Cutscene entering Renoir" mdxType="Menu">
      <h5 {...{
        "id": "pictos-16"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Maelle:`}<ul parentName="li">
            <li parentName="ul">{`-Slot 1`}</li>
            <li parentName="ul">{`-Slot 2`}</li>
            <li parentName="ul">{`+(S3) Burning Mark > Dead Energy II`}</li>
          </ul></li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "renoir-140186hp-050"
      }}>{`Renoir 140186HP (0:50)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`51750XP (NB), $4990, Melarum + 3 Polished Chroma Catalyst + 0-2 Recoat`}</p>
      </blockquote>
      <blockquote>
        <ul parentName="blockquote">
          <li parentName="ul">{`Massive amount of chroma: Gradient once he jumps into the air.`}</li>
          <li parentName="ul">{`Melee combo: 5, 4th hit is later than it looks.`}</li>
          <li parentName="ul">{`Giant pool of chroma: jump`}</li>
          <li parentName="ul">{`Attacks from a distance: 4 hit, look for slowdown.`}</li>
          <li parentName="ul">{`Vanish an expeditioner: Gradient before he strikes black orb.`}</li>
        </ul>
      </blockquote>
      <blockquote>
        <p parentName="blockquote">{`You probably want to counter 1 move on this fight.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-1-13"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Rain of Fire`}</li>
        <li parentName="ul">{`Lune: Wildfire `}<strong parentName="li">{`(Fail QTE)`}</strong></li>
        <li parentName="ul">{`Verso: Powerful`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-8"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Energy Tint Lune`}</li>
        <li parentName="ul">{`Lune: Ice Lance`}</li>
        <li parentName="ul">{`Maelle: Healing Tint Lune if she didn't crit herself / Nothing / Offensive Switch`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-5"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Attack > Leadership / Energy Tint. If you did Offensive Switch can just do the Leadership / Energy Tint`}</li>
        <li parentName="ul">{`Lune: Lightning Dance (1.2)`}</li>
      </ul>
    </Battle>
    <h3 {...{
      "id": "camp-5"
    }}>{`Camp`}</h3>
    <p>{`Go to sleep.`}</p>
    <h3 {...{
      "id": "continent-3"
    }}>{`Continent`}</h3>
    <h3 {...{
      "id": "visages"
    }}>{`Visages`}</h3>
    <Menu timing="Cutscene before flag" mdxType="Menu">
      <h5 {...{
        "id": "formation-2"
      }}>{`Formation`}</h5>
      <ul>
        <li parentName="ul">{`-Lune, +Lune, -Maelle, +Monoco`}</li>
      </ul>
      <h5 {...{
        "id": "weapons-2"
      }}>{`Weapons`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Delaram`}</li>
      </ul>
    </Menu>
    <p><strong parentName="p">{`Talk to the Plazza Flag`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Go to Joyous Vale (Back left)`}</p>
    <Menu timing="Cutscene transition entering Mask" mdxType="Menu">
      <h5 {...{
        "id": "pictos-17"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`-Combo Attack`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina-10"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Lune:`}<ul parentName="li">
            <li parentName="ul">{`(R3) +Augmented First Strike`}</li>
            <li parentName="ul">{`-Critical Burn`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`Pick up `}<strong parentName="p">{`Confident Fighter`}</strong>{`.`}</p>
    <Menu timing="Before Moisonneusse fight" mdxType="Menu">
      <h5 {...{
        "id": "pictos-18"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Lune:`}<ul parentName="li">
            <li parentName="ul">{`(Triangle) +Confident Fighter > Energising Start I`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina-11"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Lune:`}<ul parentName="li">
            <li parentName="ul">{`+Energising Start I`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`Run into fight closest to flag.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "2-moisonneusse-hat-guy"
      }}>{`2 Moisonneusse Hat Guy`}</h4>
      <ul>
        <li parentName="ul">{`Verso: Perfect Recovery`}</li>
        <li parentName="ul">{`Lune: Wildfire (Fail QTE)`}</li>
        <li parentName="ul">{`Monoco: Flee`}</li>
      </ul>
    </Battle>
    <p>{`Take flag back to `}<strong parentName="p">{`Plazza`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Go to `}<strong parentName="p">{`Sadness Vale`}</strong>{`.`}</p>
    <Menu timing="Cutscene entering Sadness Vale" mdxType="Menu">
      <h5 {...{
        "id": "formation-3"
      }}>{`Formation`}</h5>
      <p>{`-Monoco, +Sciel`}</p>
      <h5 {...{
        "id": "weapons-3"
      }}>{`Weapons`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Dualiso`}</li>
      </ul>
    </Menu>
    <p>{`Pick up `}<strong parentName="p">{`Glass Cannon`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Go to flag, warp to `}<strong parentName="p">{`Plazza`}</strong>{`.`}</p>
    <p>{`Go to Merchant.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "buy-1"
      }}>{`Buy`}</h5>
      <ul>
        <li parentName="ul">{`4 Resplendant Catalyst`}</li>
        <li parentName="ul">{`3 Color of Lumina`}</li>
      </ul>
    </Menu>
    <Menu timing="Before Mask Keeper" mdxType="Menu">
      <h5 {...{
        "id": "pictos-19"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Sciel:`}<ul parentName="li">
            <li parentName="ul">{`(S3) +Glass Cannon`}</li>
          </ul></li>
      </ul>
    </Menu>
    <Menu timing="Entering Mask Keeper fight" mdxType="Menu">
      <h5 {...{
        "id": "lumina-12"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Lune: -Augmented First Strike`}</li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "visages-185114hp"
      }}>{`Visages 185114HP`}</h4>
      <blockquote>
        <p parentName="blockquote">{`Need 440 speed for phase 1`}</p>
      </blockquote>
      <blockquote>
        <ul parentName="blockquote">
          <li parentName="ul">{`Determination Mask: Parry, Jump, Parry. Very easy audio cues`}</li>
          <li parentName="ul">{`Build shields with Peace Mask: 4 Parries on audio cue`}</li>
          <li parentName="ul">{`Anxiety Mask: 2 Parry, slight delay from audio cue.`}</li>
          <li parentName="ul">{`Doubt Mask: 5 Parry, go off visual cues. 1st one is slower than it looks. Audio cue is too early.`}</li>
        </ul>
      </blockquote>
      <blockquote>
        <p parentName="blockquote">{`There's lot's of variations here, I'll just put the slow consistent version for now.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-11"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Attack > Shoot twice, Berserk Slash`}</li>
        <li parentName="ul">{`Lune: Elemental Trick`}</li>
        <li parentName="ul">{`Sciel: Intervention Lune`}</li>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
      </ul>
      <p>{`Parry & Counter for damage.`}</p>
      <h5 {...{
        "id": "turn-1-14"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Wildfire (If damage high, 1.1 QTE`}</li>
        <li parentName="ul">{`Verso: Leadership`}</li>
        <li parentName="ul">{`Sciel: Intervention Lune`}</li>
        <li parentName="ul">{`Lune: Gradient (Should kill) > Energy Tint Sciel`}</li>
      </ul>
      <h4 {...{
        "id": "mask-keeper-185114hp-208"
      }}>{`Mask Keeper 185114HP (2:08)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`157690XP, $11760, Immaculate + 6 Resplendent Chroma Catalyst x6 + 0-3 Recoat`}</p>
      </blockquote>
      <blockquote>
        <ul parentName="blockquote">
          <li parentName="ul">{`Attacks the Expedition: 4 Parries, visual cue off the circle build up of his attack.`}</li>
          <li parentName="ul">{`Swing Combo: 3 Parry, 2nd Parry tiny delay after 1st.`}</li>
          <li parentName="ul">{`Attacks like a Storm: 4 parries, visual/audio cue.`}</li>
          <li parentName="ul">{`Sets fire to his sword: 3 quick parries into a gradient`}</li>
        </ul>
      </blockquote>
      <p>{`Dodge his moves, no benefit from parries.`}</p>
      <h5 {...{
        "id": "turn-1-15"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
        <li parentName="ul">{`Verso: Attack > Powerful`}</li>
        <li parentName="ul">{`Sciel: Intervention`}</li>
        <li parentName="ul">{`Lune: Gradient > Lightning Dance`}</li>
      </ul>
    </Battle>
    <h3 {...{
      "id": "camp-6"
    }}>{`Camp`}</h3>
    <p>{`Go to Curator.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-weapons-3"
      }}>{`Upgrade Weapons`}</h5>
      <ul>
        <li parentName="ul">{`Sciel: Scieleson +5 (11)`}</li>
        <li parentName="ul">{`Lune: Lighterim +5 (14)`}</li>
      </ul>
    </Menu>
    <p>{`Go to sleep.`}</p>
    <h3 {...{
      "id": "sirene"
    }}>{`Sirene`}</h3>
    <Menu timing="Cutscene at entrance before elevator" mdxType="Menu">
      <h5 {...{
        "id": "pictos-20"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Sciel: `}<ul parentName="li">
            <li parentName="ul">{`+Immaculate`}</li>
            <li parentName="ul">{`+Confident Fighter (No Swap)`}</li>
          </ul></li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`Try to remove ES1 from Sciel here too. If done fast, it's 1U1L. For some reason, the game puts you on Immaculate.`}</p>
      </blockquote>
    </Menu>
    <Menu timing="Jump down stairs after first elevator. Needed before Ballet fight" mdxType="Menu">
      <h5 {...{
        "id": "weapons-4"
      }}>{`Weapons`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Delaram`}</li>
      </ul>
    </Menu>
    <p>{`Run into group of Ballets.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "ballets-027"
      }}>{`Ballets (0:27)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`21624XP (NB), $1410, Ballaro LV13`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-12"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Perfect Recovery`}</li>
        <li parentName="ul">{`Lune: Wildfire (Fail QTE)`}</li>
        <li parentName="ul">{`Sciel: Skip`}</li>
      </ul>
      <p>{`Have them kill Sciel, bring in 2nd party.`}</p>
      <h5 {...{
        "id": "turn-1-16"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Monoco/Maelle: Flee`}</li>
      </ul>
    </Battle>
    <Menu timing="Jump down in Shield Affinity area" mdxType="Menu">
      <h5 {...{
        "id": "pictos-21"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`+Combo Attack`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina-13"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Sciel:`}<ul parentName="li">
            <li parentName="ul">{`-Energising Start I`}</li>
            <li parentName="ul">{`+Critical Moment`}</li>
            <li parentName="ul">{`+At Death's Door`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`Take path to the left, break Paint Cage and pick up `}<strong parentName="p">{`Shield Affinity`}</strong>{`.`}</p>
    <Menu timing="Any smaller jump before Glissando" mdxType="Menu">
      <h5 {...{
        "id": "weapons-5"
      }}>{`Weapons`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Dualiso`}</li>
      </ul>
    </Menu>
    <p>{`Pick up `}<strong parentName="p">{`Color of Lumina`}</strong>{` directly on the way.`}</p>
    <Menu timing="Big jump down before area with Tisseur" mdxType="Menu">
      <h5 {...{
        "id": "pictos-22"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Lune:`}<ul parentName="li">
            <li parentName="ul">{`+Shield Affinity`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`Go to flag `}<strong parentName="p">{`before Glissando`}</strong>{`. Need to tag it for later.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-attributes-7"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Sciel: +18 Luck (18)`}</li>
        <li parentName="ul">{`Lune: +6 Might (25), +7 Defense (12), +2 Luck (6)`}</li>
        <li parentName="ul">{`Verso: +18 Agility (46)`}</li>
      </ul>
      <h5 {...{
        "id": "learn-skills-6"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Sciel: +Sealed Fate, +Card Weaver`}</li>
        <li parentName="ul">{`Sciel: Equip Card Weaver Right-Bottom, Equip Sealed Fate Left-Bottom, Equip Twilight Slash Right-Middle`}</li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "glissando-350757hp-058"
      }}>{`Glissando 350757HP (0:58)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`51897XP, $2820, 1 Resplendent Chroma Catalyst`}<br parentName="p"></br>{`
`}{`515 speed seems to be the cutoff for him to not get 2 moves in T1.`}</p>
      </blockquote>
      <blockquote>
        <ul parentName="blockquote">
          <li parentName="ul">{`Enchants its target: 1 hit. 2 explosions > Parry. Use rhythm.`}</li>
          <li parentName="ul">{`Smashes its head: 2 Parry, can visually/audio react`}</li>
          <li parentName="ul">{`Smashes its tail: 3 Parry, need to find cue. 1st visual on slowdown, 2nd audio, 3rd delayed audio.`}</li>
          <li parentName="ul">{`Summons ballets: 3 jumps, easy.`}</li>
          <li parentName="ul">{`Attacks with her fabric: one on each character, not sure on timing cue yet.`}</li>
        </ul>
      </blockquote>
      <h5 {...{
        "id": "turn-0-13"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Energy Tint Sciel`}</li>
        <li parentName="ul">{`Lune: Elemental Trick`}</li>
        <li parentName="ul">{`Sciel: Card Weaver > Intervention Lune`}</li>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
      </ul>
      <p>{`You can dodge his attack.`}</p>
      <h5 {...{
        "id": "turn-1-17"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Attack > Shoot till C Rank, Leadership`}</li>
        <li parentName="ul">{`Lune: Wildfire`}</li>
        <li parentName="ul">{`Sciel: Gradient > Intervention Lune`}</li>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
      </ul>
    </Battle>
    <Menu timing="Cutscene menu entering Sirene fight" mdxType="Menu">
      <h5 {...{
        "id": "weapons-6"
      }}>{`Weapons`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Delaram`}</li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "sirene-303990hp-108"
      }}>{`Sirene 303990HP (1:08)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`129744XP, $7050, Tisseron, Energising Turn, 3 Resplendent, 0-3 Recoat`}<br parentName="p"></br>{`
`}{`She goes frantic at 80%? HP? After she does, her next move will be Grand Ballet.`}<br parentName="p"></br>{`
`}{`If you transition her there with a parry off her 1st move, she will skip her 2nd move.`}</p>
      </blockquote>
      <blockquote>
        <ul parentName="blockquote">
          <li parentName="ul">{`Glissandos: 2 Parries`}</li>
          <li parentName="ul">{`Charm: 1 Parry, same timing as Glissando enchants. 2 Explosions > Parry`}</li>
          <li parentName="ul">{`Seduce: Gradient`}</li>
          <li parentName="ul">{`Grand Ballet: 5 Hits, watch ballets + audio cue. 1st one is earlier than you'd think, last one you have to be patient for.`}</li>
        </ul>
      </blockquote>
      <h5 {...{
        "id": "turn-0-14"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Berserk Slash`}</li>
        <li parentName="ul">{`Lune: Elemental Trick`}</li>
        <li parentName="ul">{`Sciel: Card Weaver > Twilight Slash`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`If she goes frantic before her move, we did too much damage. Adjust with QTEs next time.`}</p>
      </blockquote>
      <p>{`Parry Glissando's, she should go frantic`}</p>
      <blockquote>
        <p parentName="blockquote">{`If you still have Dualiso on, Attack before Leadership`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-1-18"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Leadership`}</li>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
        <li parentName="ul">{`Sciel: Gradient > Sealed Fate`}</li>
      </ul>
    </Battle>
    <h3 {...{
      "id": "camp-7"
    }}>{`Camp`}</h3>
    <p>{`Go to sleep`}</p>
    <h3 {...{
      "id": "the-continent-2"
    }}>{`The Continent`}</h3>
    <p>{`Go to the Monolith`}</p>
    <h3 {...{
      "id": "the-monolith"
    }}>{`The Monolith`}</h3>
    <Menu timing="Before Feetress, preferably on jump into roll" mdxType="Menu">
      <h5 {...{
        "id": "formation-4"
      }}>{`Formation`}</h5>
      <p>{`-Verso, +Maelle, -Lune, -Sciel`}</p>
    </Menu>
    <Menu timing="Cutscene entering Feetress fight" mdxType="Menu">
      <h5 {...{
        "id": "weapons-7"
      }}>{`Weapons`}</h5>
      <ul>
        <li parentName="ul">{`Sciel: Tisseron`}</li>
        <li parentName="ul">{`Verso: Dualiso`}</li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "the-feetress"
      }}>{`The Feetress`}</h4>
      <p>{`Skip x2`}</p>
    </Battle>
    <Menu timing="Before Chevaliers fight" mdxType="Menu">
      <p><em parentName="p">{`Try to spread this menu out between jumps.`}</em></p>
      <h5 {...{
        "id": "formation-5"
      }}>{`Formation`}</h5>
      <p>{`+Verso, -Maelle, +Lune, +Sciel`}</p>
      <h5 {...{
        "id": "pictos-23"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Lune:`}<ul parentName="li">
            <li parentName="ul">{`+Weakness Gain > Inverted Affinity`}</li>
          </ul></li>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`+Energising Turn > Critical Moment`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina-14"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`+Critical Moment`}</li>
          </ul></li>
        <li parentName="ul">{`Lune:`}<ul parentName="li">
            <li parentName="ul">{`+Inverted Affinity`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`Pick up `}<strong parentName="p">{`Weakness Gain`}</strong>{` at the end of the `}<strong parentName="p">{`Tainted Stone Wave Cliffs`}</strong>{`. It's behind the statue on the right.`}</p>
    <p>{`Go to any flag along the way.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-attributes-8"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Lune: +9 Might (34)`}</li>
        <li parentName="ul">{`Verso: +6 Might (38)`}</li>
        <li parentName="ul">{`Sciel: +5 Might (61), +4 Agility (5)`}</li>
      </ul>
      <h5 {...{
        "id": "learn-skills-7"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Sciel: +All Set, Equip Right-Top`}</li>
        <li parentName="ul">{`Lune: +Storm Caller, Equip Right-`}<strong parentName="li">{`Middle`}</strong></li>
      </ul>
    </Menu>
    <p>{`In Lumiere, fight the first battle with Chevaliers.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "chevaliers"
      }}>{`Chevaliers`}</h4>
      <ul>
        <li parentName="ul">{`Lune Ice Lance, rest skip. Bring in 2nd party, flee.`}</li>
      </ul>
    </Battle>
    <Menu timing="Cutscene entering Renoir 2 fight" mdxType="Menu">
      <h5 {...{
        "id": "lumina-15"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Maelle:`}<ul parentName="li">
            <li parentName="ul">{`+At Death's Door`}</li>
            <li parentName="ul">{`+Dead Energy II`}</li>
          </ul></li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "renoir-2-370890hp-105"
      }}>{`Renoir 2 370890HP (1:05)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`173736XP, $8520, Second Chance + 3 Resplendent Chroma Catalyst`}</p>
      </blockquote>
      <blockquote>
        <ul parentName="blockquote">
          <li parentName="ul">{`Attempts to Vanish: 2 hit, Parry into Gradient. Parry right before he hits black orb. Gradient when back turned.`}</li>
          <li parentName="ul">{`Melee Combo: 6 hit`}</li>
          <li parentName="ul">{`Incredible amount of chroma: 2 Parries, Gradient. Parry as soon as you see the ball shrink.`}</li>
          <li parentName="ul">{`Waves of Chroma: 5 Parry, last is delayed`}</li>
          <li parentName="ul">{`Attacks from a distance: 4 attacks, 1st 3 parry on slow down. 4th is ground pound.`}</li>
        </ul>
      </blockquote>
      <h5 {...{
        "id": "turn-0-15"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Attack > 1 Shot, Leadership`}</li>
        <li parentName="ul">{`Lune: Storm Caller`}</li>
        <li parentName="ul">{`Sciel: Card Weaver > Intervention Lune`}</li>
        <li parentName="ul">{`Lune: Elemental Trick`}</li>
      </ul>
      <p>{`Counter his move.`}</p>
      <blockquote>
        <p parentName="blockquote">{`You want to get his health as close to as half as possible before Sciel's turn.`}<br parentName="p"></br>{`
`}{`After Verso Attack's, you can use the top point of the diamond as an indicator for what HP to use Lightning Dance at. Want HP to be at that top point, or just pixels past it.`}<br parentName="p"></br>{`
`}{`For Verso shots, prioritize doing a C-Rank Leadership if possible.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-1-19"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Attack > Shots, Leadership (Can Powerful if multihit AoE parry)`}</li>
        <li parentName="ul">{`Lune: Shots if needed, Lightning Dance`}</li>
        <li parentName="ul">{`Sciel: Headshots until 3AP (Want minimum without Powerful), Gradient > Sealed Fate`}</li>
      </ul>
      <p>{`This should kill, if not Abandon Battle instantly and retry.`}</p>
    </Battle>
    <Menu timing="Before Paintress" mdxType="Menu">
      <h5 {...{
        "id": "pictos-24"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`+Glass Cannon > Energising Turn (Swap)`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina-16"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Lune:`}<ul parentName="li">
            <li parentName="ul">{`(R3) +Glass Cannon`}</li>
          </ul></li>
        <li parentName="ul">{`Sciel:`}<ul parentName="li">
            <li parentName="ul">{`-Inverted Affinity`}</li>
            <li parentName="ul">{`+Glass Cannon`}</li>
          </ul></li>
      </ul>
    </Menu>
    <Menu timing="Cutscene entering Paintress fight" mdxType="Menu">
      <h5 {...{
        "id": "lumina-17"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Verso: +Energising Start I (Insurance for T1 of Paintress)`}</li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "the-paintress-482157hp-408"
      }}>{`The Paintress 482157HP (4:08)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`173736XP, $8519, Painted Power + 3 Resplendent Chroma Catalyst`}<br parentName="p"></br>{`
`}{`Need >= 744 speed for Rush strat.`}</p>
      </blockquote>
      <blockquote>
        <ul parentName="blockquote">
          <li parentName="ul">{`Void Meteors: 7 projectiles left to right. They kind of explode before launching, parry as soon as you see it.`}</li>
          <li parentName="ul">{`Gradient Attack: 1 Gradient`}</li>
          <li parentName="ul">{`Chroma Waves: 4 hits, 2nd one right after 1st. Audio cue works. Parry on start of cue.`}</li>
          <li parentName="ul">{`Scatters Chroma: 5 hits, parry once the black waves go into the circle. No more waves around circle > parry.`}</li>
          <li parentName="ul">{`Manipulates Rocks from the Monolith: 3 hit AoE, parry after the rock moves back?`}</li>
        </ul>
      </blockquote>
      <p>{`You want to slightly underdamage, so you can kill with the parry counter on her 4th move.`}</p>
      <h5 {...{
        "id": "turn-0-16"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Skip`}</li>
        <li parentName="ul">{`Lune: Elemental Trick`}</li>
        <li parentName="ul">{`Sciel: Intervention Lune`}</li>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
      </ul>
      <p>{`Dodge Meteors`}</p>
      <h5 {...{
        "id": "turn-1-20"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Verso: (Shoot and/or Attack for Rank C), Leadership`}</li>
        <li parentName="ul">{`Lune: Elemental Trick`}</li>
        <li parentName="ul">{`Sciel: All Set`}</li>
      </ul>
      <p>{`Parry Gradient, Parry 3 hits of Chroma waves and dodge one.`}</p>
      <h5 {...{
        "id": "turn-2-9"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Verso: `}<strong parentName="li">{`Attack`}</strong>{` > Berserk Slash`}</li>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
        <li parentName="ul">{`Sciel: Gradient > Sealed Fate`}</li>
      </ul>
      <p>{`Parry all 5 chroma scatters, transition with counter.`}</p>
      <h4 {...{
        "id": "phase-2"
      }}>{`Phase 2`}</h4>
      <blockquote>
        <ul parentName="blockquote">
          <li parentName="ul">{`Summons giant brush of light: 3 hit aoe, parry on swing. Has audio cue similar to Chroma Waves`}</li>
          <li parentName="ul">{`Flies into the air: 5 hit, 2nd dodge on twirl, 3rd is slow, 4th is right after 3rd.`}</li>
          <li parentName="ul">{`Tears reality apart: 5 projectiles, dodge / parry at their "arc". Randomly start from left or right.`}</li>
          <li parentName="ul">{`Paintress unleashes: 7 single target into AoE`}</li>
          <li parentName="ul">{`Attacks from afar: Jump into 3 parry. Patient for jump`}</li>
        </ul>
      </blockquote>
      <h5 {...{
        "id": "turn-1-21"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Attack > Powerful`}</li>
        <li parentName="ul">{`Lune: Elemental Trick`}</li>
        <li parentName="ul">{`Sciel: Gradient > Sealed Fate`}</li>
      </ul>
      <p>{`She will get 2 turns here, Counter the Giant Brush and dodge "Flies into the Air".`}</p>
      <h5 {...{
        "id": "turn-2-10"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
        <li parentName="ul">{`Verso: Berserk Slash`}</li>
        <li parentName="ul">{`Sciel: Gradient > Sealed Fate`}</li>
      </ul>
      <h4 {...{
        "id": "phase-3-72323hp"
      }}>{`Phase 3 ~72323HP`}</h4>
      <h5 {...{
        "id": "turn-1-22"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Skip / Attack if Verso healed and not S-rank.`}</li>
        <li parentName="ul">{`Verso: Defiant Strike`}</li>
        <li parentName="ul">{`Sciel: Sealed Fate`}</li>
      </ul>
    </Battle>
    <h2 {...{
      "id": "act-iii"
    }}>{`Act III`}</h2>
    <h3 {...{
      "id": "lumiere"
    }}>{`Lumiere`}</h3>
    <Menu timing="Cutscene before talking to Renoir" mdxType="Menu">
      <h5 {...{
        "id": "pictos-25"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`+Painted Power > Combo Attack`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina-18"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: +Augmented First Strike`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`Augmented First Strike is optional. If you don't equip it, shoot Yellow Harvest Merchant 3 times before attacking.`}</p>
      </blockquote>
    </Menu>
    <h3 {...{
      "id": "camp-8"
    }}>{`Camp`}</h3>
    <p>{`Talk to everyone, go to campfire.`}<br parentName="p"></br>{`
`}{`Write in Gustave's Journal to learn `}<strong parentName="p">{`Gustave's Homage`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Option 2 to exit camp.`}</p>
    <h3 {...{
      "id": "continent-4"
    }}>{`Continent`}</h3>
    <p>{`Go to `}<strong parentName="p">{`Dark Shores`}</strong>{`.`}</p>
    <h3 {...{
      "id": "dark-shores"
    }}>{`Dark Shores`}</h3>
    <p>{`Go to flag.`}</p>
    <Menu timing="Flag in Dark Shores" mdxType="Menu">
      <h5 {...{
        "id": "learn-skills-8"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Verso: +Overload, Equip Left-Top`}</li>
        <li parentName="ul">{`Maelle: +Mezzo Forte, +Last Chance`}</li>
        <li parentName="ul">{`Maelle: Equip Last Chance Left-Top, Mezzo Forte Left-Bottom, Gustave's Homage Right-Bottom`}</li>
        <li parentName="ul">{`Maelle: +Phantom Strike, Equip Right-Middle`}</li>
      </ul>
    </Menu>
    <p>{`Pick up `}<strong parentName="p">{`$3848`}</strong>{`. Pick up `}<strong parentName="p">{`In Media Res`}</strong>{`. Pick up `}<strong parentName="p">{`$15390`}</strong>{` and exit.`}</p>
    <h3 {...{
      "id": "continent-5"
    }}>{`Continent`}</h3>
    <p>{`Go to Camp.`}</p>
    <h3 {...{
      "id": "camp-9"
    }}>{`Camp`}</h3>
    <p>{`Get Esquie Relationship to 6.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "francois-015"
      }}>{`Francois (0:15)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`14175XP, $815`}</p>
      </blockquote>
      <p>{`Attack > Overload > Shoot 4 times, Berserk Slash`}</p>
    </Battle>
    <p>{`Write in Gustave's Journal to learn `}<strong parentName="p">{`Gustave's Homage`}</strong>{` if you didn't earlier.`}<br parentName="p"></br>{`
`}{`Exit camp.`}</p>
    <h3 {...{
      "id": "continent-6"
    }}>{`Continent`}</h3>
    <p>{`Head to `}<strong parentName="p">{`Verso's Drafts`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Pick up 2 underwater `}<strong parentName="p">{`5 Colour of Lumina`}</strong>{` on the way.`}</p>
    <h3 {...{
      "id": "versos-drafts"
    }}>{`Verso's Drafts`}</h3>
    <p>{`Go east, `}<strong parentName="p">{`Wheeeee`}</strong>{` 3 Esquie statues.`}</p>
    <Menu timing="Jump down after Whee-ing 1st statue." mdxType="Menu">
      <h5 {...{
        "id": "pictos-26"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: `}<ul parentName="li">
            <li parentName="ul">{`+Painted Power`}</li>
            <li parentName="ul">{`+In Media Res`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`Pick up `}<strong parentName="p">{`Slowing Attack`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Talk to Gestral by Esquie statues to get `}<strong parentName="p">{`Piece of Cake`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Go to the diving board, knock off the Gestral and jump down. Start heading to the left.`}</p>
    <Menu timing="Diving board jump" mdxType="Menu">
      <h5 {...{
        "id": "formation-6"
      }}>{`Formation`}</h5>
      <p>{`Maelle, Lune, Sciel`}</p>
    </Menu>
    <p>{`Pop Paint Cage (1 on with cliff with enemies, 1 by Candy Land entrance, 1 above cage), and get `}<strong parentName="p">{`Esquim`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Take grapple west of Paint Cage towards Balloon Gestral.`}<br parentName="p"></br>{`
`}{`Shoot 5 balloons, fight Half-Baked Gestral.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "half-baked-gestral"
      }}>{`Half Baked Gestral`}</h4>
      <blockquote>
        <p parentName="blockquote">{`$2092, 0-2 Grandiose`}</p>
      </blockquote>
      <p>{`Shoot balloons.`}</p>
    </Battle>
    <blockquote>
      <p parentName="blockquote">{`Take note of drops from Gestral fights, can cut purchases/money if Grandiose drops.`}</p>
    </blockquote>
    <p>{`Jump down Waterfall, get `}<strong parentName="p">{`Toy Boat`}</strong>{`.`}</p>
    <Menu timing="Jump down to waterfall" mdxType="Menu">
      <h5 {...{
        "id": "pictos-27"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Sciel:`}<ul parentName="li">
            <li parentName="ul">{`+Trigger-happy > Immaculate`}</li>
            <li parentName="ul">{`+Slowing Attack > Confident Fighter`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`Get `}<strong parentName="p">{`Gradient Overcharge`}</strong>{`. There are shortcuts you can take here, refer to vids for examples if needed.`}</p>
    <p>{`Go to Very Very Cool Gestral, ride ride with all 5 characters to get `}<strong parentName="p">{`Piece of Cake`}</strong>{`.`}</p>
    <blockquote>
      <p parentName="blockquote">{`$2094, 199584XP, 0-1 Grandiose`}<br parentName="p"></br>{`
`}{`Go to Monseiur Frappe, challenge him and get `}<strong parentName="p">{`Feint`}</strong>{`. `}</p>
    </blockquote>
    <p>{`Need Maelle to survive. If Lune dies, she'll be a level short before Sprong and you'll have to adjust Lumina.`}<br parentName="p"></br>{`
`}{`Take grapple down by Candyland entrance and get `}<strong parentName="p">{`Esqium`}</strong>{`.`}</p>
    <p>{`Go to Merchant.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "buy-2"
      }}>{`Buy`}</h5>
      <ul>
        <li parentName="ul">{`5 Grandiose Catalyst (5)`}</li>
        <li parentName="ul">{`3 Color of Lumina (25)`}</li>
      </ul>
    </Menu>
    <p>{`Go to `}<strong parentName="p">{`Reverie Path`}</strong>{` flag.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-attributes-9"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Lune: +21 Agility (53)`}</li>
        <li parentName="ul">{`Maelle: +42 Agility (43)`}</li>
      </ul>
      <h5 {...{
        "id": "upgrade-resources"
      }}>{`Upgrade Resources`}</h5>
      <ul>
        <li parentName="ul">{`Lune: +25 Lumina (60)`}</li>
      </ul>
      <p>{`Back to Continent`}</p>
    </Menu>
    <h3 {...{
      "id": "continent-7"
    }}>{`Continent`}</h3>
    <p>{`Pick up `}<strong parentName="p">{`$5840`}</strong>{` in area by Dark Shores.`}<br parentName="p"></br>{`
`}{`Head towards `}<strong parentName="p">{`Yellow Harvest`}</strong>{`.`}</p>
    <h3 {...{
      "id": "yellow-harvest"
    }}>{`Yellow Harvest`}</h3>
    <Menu timing="Before Glaise fight" mdxType="Menu">
      <h5 {...{
        "id": "weapons-8"
      }}>{`Weapons`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Esquim`}</li>
        <li parentName="ul">{`Maelle: Esqium`}</li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "glaise-75000hp-017"
      }}>{`Glaise ~75000HP (0:17)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`29028XP, $3550, Plenum, Energising Attack I, 3 Polished`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-17"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Shoot 3 times, Last Chance`}</li>
        <li parentName="ul">{`Lune: Wildfire (Fail QTE)`}</li>
        <li parentName="ul">{`Sciel: Intervention`}</li>
        <li parentName="ul">{`Maelle: Attack`}</li>
      </ul>
    </Battle>
    <p>{`Take left path, menu on the jump down.`}</p>
    <Menu timing="Big jump down in Yellow Harvest" mdxType="Menu">
      <h5 {...{
        "id": "pictos-28"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Lune:`}<ul parentName="li">
            <li parentName="ul">{`+Feint > Weakness Gain`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina-19"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Lune:`}<ul parentName="li">
            <li parentName="ul">{`-Energising Start I`}</li>
            <li parentName="ul">{`+Empowering Attack`}</li>
            <li parentName="ul">{`+Exposing Attack`}</li>
            <li parentName="ul">{`+Immaculate`}</li>
            <li parentName="ul">{`+Painted Power`}</li>
          </ul></li>
      </ul>
    </Menu>
    <Menu timing="Smaller jump down." mdxType="Menu">
      <h5 {...{
        "id": "formation-7"
      }}>{`Formation`}</h5>
      <p>{`-+Maelle`}</p>
    </Menu>
    <p>{`Go to Merchant, fight him.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "pinnaby-12000hp-004"
      }}>{`Pinnaby ~12000HP (0:04)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`4354XP, $533`}</p>
      </blockquote>
      <p>{`Maelle: Attack (Add 3 shots if no Augmented First Strike)`}</p>
    </Battle>
    
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "buy-3"
      }}>{`Buy`}</h5>
      <ul>
        <li parentName="ul">{`Teamwork ($9120)`}</li>
        <li parentName="ul">{`Auto Death ($5320)`}</li>
      </ul>
    </Menu>
    <Menu timing="Jump down" mdxType="Menu">
      <h5 {...{
        "id": "pictos-29"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Maelle:`}<ul parentName="li">
            <li parentName="ul">{`+Teamwork > Burning Mark`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`Go to flag, back to Continent.`}</p>
    <h3 {...{
      "id": "continent-8"
    }}>{`Continent`}</h3>
    <p>{`Go fight Sprong.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "sprong-3964471hp-025"
      }}>{`Sprong 3964471HP (0:25)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`1056000XP, $11543, 3 Grandiose`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-18"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Elemental Trick`}</li>
        <li parentName="ul">{`Sciel: Intervention Lune`}</li>
        <li parentName="ul">{`Lune: Attack`}</li>
        <li parentName="ul">{`Maelle: Energy Tint Sciel`}</li>
        <li parentName="ul">{`Sciel: Intervention Lune`}</li>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
      </ul>
    </Battle>
    <p>{`Go to `}<strong parentName="p">{`Falling Leaves`}</strong>{`.`}</p>
    <h3 {...{
      "id": "falling-leaves"
    }}>{`Falling Leaves`}</h3>
    <p>{`Go to merchant.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "buy-4"
      }}>{`Buy`}</h5>
      <ul>
        <li parentName="ul">{`Beneficial Contamination ($42175)`}</li>
      </ul>
    </Menu>
    <p>{`Go to flag and exit to Continent`}</p>
    <h3 {...{
      "id": "continent-9"
    }}>{`Continent`}</h3>
    <p>{`Go to Serpenphare.`}</p>
    <Menu timing="Before Serpenphare" mdxType="Menu">
      <h5 {...{
        "id": "pictos-30"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Lune:`}<ul parentName="li">
            <li parentName="ul">{`+Cheater > Shield Affinity`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`Go to Serpenphare.`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "serpenphare-hp10987742-020"
      }}>{`Serpenphare HP<10987742 (0:20)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`2340000XP, $22240, Energy Master, 1 Perfect + 3 Grandiose`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-19"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Elemental Trick > Attack`}</li>
        <li parentName="ul">{`Sciel: Invervention Lune`}</li>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
      </ul>
    </Menu>
    <p>{`Go to Gross Tete`}</p>
    <Menu timing="Before Gross Tete" mdxType="Menu">
      <h5 {...{
        "id": "pictos-31"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Sciel: `}<ul parentName="li">
            <li parentName="ul">{`+Energy Master > Trigger-happy`}</li>
          </ul></li>
        <li parentName="ul">{`Lune: `}<ul parentName="li">
            <li parentName="ul">{`+Beneficial Contamination > First Strike`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina-20"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Lune: +First Strike`}</li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "gross-tete-hp3908753-020"
      }}>{`Gross Tete HP<3908753 (0:20)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`81000XP, $3612, Warming Up, 1 Resplendent`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-20"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Elemental Trick > Attack`}</li>
        <li parentName="ul">{`Sciel: Invervention Lune`}</li>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
      </ul>
    </Battle>
    <p><strong parentName="p">{`Fly west into battle on shore.`}</strong></p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "wm-battle"
      }}>{`WM Battle`}</h4>
      <p>{`Lune: Shoot everything to death. For Troubadour, only need 2 shots if you hit weakness.`}</p>
    </Battle>
    <p>{`Go to Frozen Hearts.`}</p>
    <h3 {...{
      "id": "frozen-hearts"
    }}>{`Frozen Hearts`}</h3>
    <p>{`Do jump and pick up `}<strong parentName="p">{`Burn Affinity`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Continue down path and fight `}<strong parentName="p">{`Chromatic Veileur`}</strong>{`.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "chromatic-veileur-014"
      }}>{`Chromatic Veileur (0:14)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`$10448, 521235XP, Energising Burn, 2 Grandiose, 5 Lumina`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-21"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Elemental Trick > Lightning Dance`}</li>
      </ul>
    </Battle>
    <p>{`Backtrack to flag, picking up `}<strong parentName="p">{`Colour of Lumina`}</strong>{` on the way.`}</p>
    <Menu timing="Jump down after Lumina pickup" mdxType="Menu">
      <h5 {...{
        "id": "formation-8"
      }}>{`Formation`}</h5>
      <p>{`-+Sciel`}</p>
    </Menu>
    <Menu timing="At flag" mdxType="Menu">
      <h5 {...{
        "id": "upgrade-attributes-10"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Sciel: +69 Agility (74)`}</li>
        <li parentName="ul">{`Maelle: +54 Agility (97)`}</li>
      </ul>
      <h5 {...{
        "id": "learn-skills-9"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Sciel: +Delaying Slash (Bottom-Left)`}</li>
      </ul>
      <h5 {...{
        "id": "upgrade-weapons-4"
      }}>{`Upgrade Weapons`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: +4 Esqium (33)`}</li>
      </ul>
      <p>{`Back to Continent.`}</p>
    </Menu>
    <h3 {...{
      "id": "continent-10"
    }}>{`Continent`}</h3>
    <p>{`Go to Old Lumiere.`}</p>
    <h3 {...{
      "id": "old-lumiere-1"
    }}>{`Old Lumiere`}</h3>
    <Menu timing="During 1st jump." mdxType="Menu">
      <h5 {...{
        "id": "lumina-21"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Sciel: (Enter from party leader to avoid Reset not working)`}<ul parentName="li">
            <li parentName="ul">{`Reset Lumina`}</li>
            <li parentName="ul">{`+Cheater`}</li>
            <li parentName="ul">{`+First Strike`}</li>
          </ul></li>
      </ul>
    </Menu>
    <Menu timing="During 2nd jump" mdxType="Menu">
      <h5 {...{
        "id": "pictos-32"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Maelle:`}<ul parentName="li">
            <li parentName="ul">{`+Cheater`}</li>
            <li parentName="ul">{`+Trigger-happy (No Swap)`}</li>
            <li parentName="ul">{`+Beneficial Contamination (No Swap)`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina-22"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Maelle:`}<ul parentName="li">
            <li parentName="ul">{`-Augmented First Strike`}</li>
            <li parentName="ul">{`+Painted Power`}</li>
            <li parentName="ul">{`+Immaculate`}</li>
            <li parentName="ul">{`+Glass Cannon`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`Fight Chromatic Danseuse.`}</p>
    <Battle mdxType="Battle">
      <p>{`We are killing 19 loops, or 39 Dancers total. A loop is 2 Dancers killed, so a typical Maelle turn is 2 loops. You won't need to count though, we will use turn order as an indicator.`}</p>
      <h4 {...{
        "id": "chromatic-danseuse-150000hp-445"
      }}>{`Chromatic Danseuse ~150000HP (4:45)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`284995717XP, $145977, Danseso, Revive Paradox, 78 Polished, `}<strong parentName="p">{`195`}</strong>{` Lumina`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-22"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Ice Lance`}</li>
        <li parentName="ul">{`Maelle: Last Chance, Shoot summons once, Mezzo Forte`}</li>
        <li parentName="ul">{`Sciel: Intervention Maelle`}</li>
      </ul>
      <p>{`The loop now is:`}</p>
      <h4 {...{
        "id": "loop"
      }}>{`Loop`}</h4>
      <ul>
        <li parentName="ul">{`Lune: Skip`}</li>
        <li parentName="ul">{`Maelle: Shoot summons 3 times, Mezzo Forte. If you missed and won't get at least 8AP, Last Chance instead.`}</li>
        <li parentName="ul">{`Sciel: Focused Foretell > Delaying Slash `}<strong parentName="li">{`Fail all QTEs`}</strong></li>
      </ul>
      <p>{`Do this until Sciel's turn before Lune's 3rd turn.`}</p>
      <h4 {...{
        "id": "end-of-loop"
      }}>{`End of Loop`}</h4>
      <ul>
        <li parentName="ul">{`Sciel: Intervention Maelle`}</li>
        <li parentName="ul">{`Maelle: Shoot main, shoot summons 3 times each.`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`Note that if you're down Lumina or money, you can extend a bit longer.`}</p>
      </blockquote>
    </Battle>
    <p>{`Go back to flag.`}</p>
    <Menu mdxType="Menu">
      <blockquote>
        <p parentName="blockquote">{`If no recoat owned, delay Lune stats until you have one.`}</p>
      </blockquote>
      <h5 {...{
        "id": "upgrade-attributes-11"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Recoat, Max Might, Defense, Agility`}</li>
        <li parentName="ul">{`Verso: Max Agility, Vitality, rest into Might`}</li>
        <li parentName="ul">{`Maelle: Max Might, Agility, Defense`}</li>
      </ul>
      <h5 {...{
        "id": "learn-skills-10"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Lune: +Elemental Genesis, Left-Middle`}</li>
        <li parentName="ul">{`Sciel: +Fortune Fury, Our Sacrifice`}</li>
        <li parentName="ul">{`Sciel: Equip Fortune Fury Left-Middle, Our Sacrifice Left-Bottom`}</li>
        <li parentName="ul">{`Maelle: +Guard Down, +Egide, Stendhal`}</li>
        <li parentName="ul">{`Maelle: Equip Stendhal Left-Bottom, Egide Right-Top`}</li>
      </ul>
      <h5 {...{
        "id": "upgrade-resources-1"
      }}>{`Upgrade Resources`}</h5>
      <ul>
        <li parentName="ul">{`Lune: +11 Lumina (135)`}</li>
        <li parentName="ul">{`Maelle: +186 Lumina (285)`}</li>
        <li parentName="ul">{`Sciel: +1 Lumina (100)`}</li>
      </ul>
      <p>{`Back to Continent`}</p>
    </Menu>
    <h3 {...{
      "id": "continent-11"
    }}>{`Continent`}</h3>
    <p>{`Go to Sirene.`}</p>
    <h3 {...{
      "id": "sirene-1"
    }}>{`Sirene`}</h3>
    <p>{`Go to flag, Fast Travel to `}<strong parentName="p">{`Crumbling Path`}</strong>{`. Go to Merchant.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "buy-5"
      }}>{`Buy`}</h5>
      <ul>
        <li parentName="ul">{`Double Mark`}</li>
        <li parentName="ul">{`Greater Powerful`}</li>
      </ul>
    </Menu>
    <p>{`Go back to flag and exit.`}</p>
    <h3 {...{
      "id": "continent-12"
    }}>{`Continent`}</h3>
    <p>{`Go to Renoir's Drafts`}</p>
    <Menu timing="Before Renoir's Drafts Merchant" mdxType="Menu">
      <h5 {...{
        "id": "pictos-33"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Maelle:`}<ul parentName="li">
            <li parentName="ul">{`+Energising Burn`}</li>
            <li parentName="ul">{`+Burn Affinity`}</li>
            <li parentName="ul">{`+Double Mark > Beneficial Contamination`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina-23"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Maelle:`}<ul parentName="li">
            <li parentName="ul">{`+Critical Moment`}</li>
            <li parentName="ul">{`+Critical Burn`}</li>
            <li parentName="ul">{`+Cheater`}</li>
            <li parentName="ul">{`+Confident Fighter`}</li>
            <li parentName="ul">{`+Burning Mark`}</li>
            <li parentName="ul">{`+Beneficial Contamination`}</li>
            <li parentName="ul">{`+Augmented First Strike`}</li>
            <li parentName="ul">{`+Teamwork`}</li>
            <li parentName="ul">{`+Shield Affinity`}</li>
            <li parentName="ul">{`+In Media Res`}</li>
            <li parentName="ul">{`+Energy Master`}</li>
          </ul></li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "renoirs-drafts"
    }}>{`Renoir's Drafts`}</h3>
    <p>{`Go to Merchant and fight him.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "grour-013"
      }}>{`Grour (0:13)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`$16254, 2000965XP, Contorso LV31, Shortcut, 1 Lumina, 1 Grandiose`}</p>
      </blockquote>
      <p>{`Maelle: Last Chance > Shoot any once, Phantom Strike`}</p>
    </Battle>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "buy-6"
      }}>{`Buy`}</h5>
      <ul>
        <li parentName="ul">{`Solo Fighter`}</li>
        <li parentName="ul">{`11 Colour of Lumina (15 total, can buy more for safety)`}</li>
      </ul>
    </Menu>
    <Menu timing="Jump down from Merchant building" mdxType="Menu">
      <h5 {...{
        "id": "formation-9"
      }}>{`Formation`}</h5>
      <p>{`-Maelle, +Verso, -Lune, -Sciel, +Maelle, +Sciel`}<br parentName="p"></br>{`
`}<em parentName="p">{`Final order is Verso, Maelle, Sciel`}</em>{`.`}</p>
    </Menu>
    <p>{`Go to Simon.`}</p>
    <Menu timing="Jump down to Simon" mdxType="Menu">
      <h5 {...{
        "id": "pictos-34"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`+Shortcut`}</li>
            <li parentName="ul">{`+Greater Powerful > Glass Cannon`}</li>
            <li parentName="ul">{`+Warming Up`}</li>
          </ul></li>
        <li parentName="ul">{`Sciel:`}<ul parentName="li">
            <li parentName="ul">{`+Second Chance > Energising Turn`}</li>
            <li parentName="ul">{`+Cheater > Slowing Attack`}</li>
            <li parentName="ul">{`+Trigger-happy > Energy Master`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina-24"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Sciel:`}<ul parentName="li">
            <li parentName="ul">{`+Inverted Affinity`}</li>
            <li parentName="ul">{`+Feint`}</li>
            <li parentName="ul">{`+Energising Turn`}</li>
            <li parentName="ul">{`+Beneficial Contamination`}</li>
          </ul></li>
        <li parentName="ul">{`Lune:`}<ul parentName="li">
            <li parentName="ul">{`+Beneficial Contamination`}</li>
            <li parentName="ul">{`+Cheater`}</li>
            <li parentName="ul">{`-Critical Moment`}</li>
            <li parentName="ul">{`+In Media Res`}</li>
            <li parentName="ul">{`+Teamwork`}</li>
          </ul></li>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`+Beneficial Contamination`}</li>
            <li parentName="ul">{`+Teamwork`}</li>
            <li parentName="ul">{`+Painted Power`}</li>
            <li parentName="ul">{`+Immaculate`}</li>
            <li parentName="ul">{`+Glass Cannon`}</li>
            <li parentName="ul">{`+Exposing Attack`}</li>
          </ul></li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "simon-p1-011"
      }}>{`Simon P1 (0:11)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`1485000XP, $25220`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-23"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Skip`}</li>
        <li parentName="ul">{`Maelle: Last Chance > shoot once, Percee`}</li>
      </ul>
    </Battle>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "simon-p2-020"
      }}>{`Simon P2 (0:20)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`1237500XP (NB), $25220,`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-24"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Powerful`}</li>
        <li parentName="ul">{`Maelle: Last Chance > Shoot once, Stendhal`}</li>
      </ul>
    </Battle>
    <p>{`Talk to flag, Back to Continent.`}</p>
    <h3 {...{
      "id": "continent-13"
    }}>{`Continent`}</h3>
    <p>{`Exit to Continent.`}</p>
    <h3 {...{
      "id": "continent-14"
    }}>{`Continent`}</h3>
    <p>{`Go to Flying Manor`}</p>
    <h3 {...{
      "id": "flying-manor"
    }}>{`Flying Manor`}</h3>
    <p>{`Take NW path first.`}</p>
    <p>{`Pick up `}<strong parentName="p">{`Powerful Mark`}</strong>{`.`}</p>
    <Menu timing="Jump down from Powerful Mark" mdxType="Menu">
      <h5 {...{
        "id": "formation-10"
      }}>{`Formation`}</h5>
      <p>{`-+Verso`}</p>
      <h5 {...{
        "id": "weapons-9"
      }}>{`Weapons`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Simoso`}</li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "chromatic-goblu-5000000hp-011"
      }}>{`Chromatic Goblu ~5000000HP (0:11)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`1603800XP, $19900, Gobluson LV28, 3 Grandiose`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-25"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Last Chance > Shoot 3 times, Percee`}</li>
      </ul>
    </Battle>
    <p>{`Talk to boy to return, take NE path.`}</p>
    <Menu timing="Jump down to Eveques" mdxType="Menu">
      <h5 {...{
        "id": "formation-11"
      }}>{`Formation`}</h5>
      <p>{`-+Sciel`}</p>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "eveques-hp2800000-028"
      }}>{`Eveques HP<2800000 (0:28)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`1659933XP, $44979, Kralim LV28, 1 Perfect, 6 Grandiose, 15 Lumina`}</p>
      </blockquote>
      <blockquote>
        <p parentName="blockquote">{`The Invincibility changes at the start of each turn, don't get tricked by it while it's loading! It also doesn't always switch.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-26"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Last Chance > Percee`}</li>
        <li parentName="ul">{`Verso: Overload > Berserk Slash`}</li>
        <li parentName="ul">{`Sciel: Intervention Verso`}</li>
        <li parentName="ul">{`Verso: Berserk Slash`}</li>
      </ul>
    </Battle>
    <p>{`Talk to boy to return. Take SE path.`}</p>
    <Menu timing="On jump down" mdxType="Menu">
      <h5 {...{
        "id": "pictos-35"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Maelle:`}<ul parentName="li">
            <li parentName="ul">{`+Solo Fighter`}</li>
            <li parentName="ul">{`+Shortcut`}</li>
            <li parentName="ul">{`+Powerful Mark`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina-25"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Maelle:`}<ul parentName="li">
            <li parentName="ul">{`+Warming Up`}</li>
            <li parentName="ul">{`+Burn Affinity`}</li>
            <li parentName="ul">{`+Double Mark`}</li>
            <li parentName="ul">{`+Energising Burn`}</li>
            <li parentName="ul">{`+Greater Powerful`}</li>
          </ul></li>
      </ul>
    </Menu>
    <Menu timing="Jumps down to Gargant" mdxType="Menu">
      <h5 {...{
        "id": "formation-12"
      }}>{`Formation`}</h5>
      <p>{`-Sciel, -Verso`}</p>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "gargant-2-danseuse-5500000hp-013"
      }}>{`Gargant, 2 Danseuse ~5500000HP (0:13)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`2662308XP, $23988, Snowim LV29, Anti-Burn LV29, Burning Death LV29, 3 Grandiose`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-27"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Last Chance, Shoot Gargant, Phantom Strike`}</li>
      </ul>
    </Battle>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "lampmaster-hp6360000-011"
      }}>{`Lampmaster HP<6360000 (0:11)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`2405700XP, $19900, Joyaro, 1 Perfect, 3 Grandiose`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-28"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Last Chance > Percee`}</li>
      </ul>
    </Battle>
    <p>{`Talk to boy to return, take SW Path.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "dualliste-15000000hp-010"
      }}>{`Dualliste ~15000000HP (0:10)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`1603800XP, $19900, Dualiso LV28, 1 Perfect, 3 Grandiose, 0-1 Recoat`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-29"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Last Chance > Percee`}</li>
      </ul>
    </Battle>
    <p>{`Talk to boy to return. Go to Clea.`}</p>
    <Menu timing="Entering Clea. 3rd ring of inner circle." mdxType="Menu">
      <h5 {...{
        "id": "formation-13"
      }}>{`Formation`}</h5>
      <p>{`+Lune, +Sciel`}</p>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "clea-1500000hp-014"
      }}>{`Clea ~1500000HP (0:14)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`2340000XP, $22240, Clea's Life, 1 Perfect, 3 Grandiose`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-30"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Last Chance > shoot once, Stendhal`}</li>
      </ul>
    </Battle>
    <p>{`Go to flag.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-weapons-5"
      }}>{`Upgrade Weapons`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Esquim +4 (33)`}</li>
      </ul>
      <p>{`Back to Continent.`}</p>
    </Menu>
    <h3 {...{
      "id": "continent-15"
    }}>{`Continent`}</h3>
    <p>{`Go to Verso's Drafts`}</p>
    <h3 {...{
      "id": "versos-drafts-1"
    }}>{`Verso's Drafts`}</h3>
    <p>{`Go to flag, fast travel to `}<strong parentName="p">{`Reverie Path`}</strong><br parentName="p"></br>{`
`}{`Go turn in Toy Boat to get `}<strong parentName="p">{`Birthday Cake`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Go to Licornapieds Station, fight battle for Double Third on the railway.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "dont-know-names-011"
      }}>{`Don't know names (0:11)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`$9423, 1089728XP, Longer Break, Damage Share, Double Third`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-31"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Last Chance > shoot once, Phantom Strike`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`Or, Last Chance > Shoot 3, 3, 2 times going left to right. Faster if you shoot fast.`}</p>
      </blockquote>
    </Battle>
    <p>{`Fight Licornapieds.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "licornapieds-010"
      }}>{`Licornapieds (0:10)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`$20940, 1995840XP, Frenzy, 6 Grandiose`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-32"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Last Chance > Percee`}</li>
      </ul>
    </Battle>
    <p>{`Back to flag, Fast Travel to `}<strong parentName="p">{`Reverie Path`}</strong>{`.`}</p>
    <blockquote>
      <p parentName="blockquote">{`If you SOMEHOW still don't have a Recoat from Lune, buy 1 from the merchant and fix her stats before Osquio.`}</p>
    </blockquote>
    <p>{`Go to Osquio.`}</p>
    <Menu timing="Before Osquio" mdxType="Menu">
      <h5 {...{
        "id": "pictos-36"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Lune:`}<ul parentName="li">
            <li parentName="ul">{`+Double Third`}</li>
            <li parentName="ul">{`+Frenzy`}</li>
          </ul></li>
      </ul>
    </Menu>
    <Menu timing="Entering Osquio fight" mdxType="Menu">
      <h5 {...{
        "id": "skills-3"
      }}>{`Skills`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: +Guard Down > Percee`}</li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "osquio-118"
      }}>{`Osquio (1:18)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`$25220, 24750000XP (No bonus), Esquiso, 1 Perfect, 3 Grandiose, 10 Lumina`}</p>
      </blockquote>
      <p>{`He will get 1 turn in, you just need to dodge. Only Lune has to survive the attack. If she dies, retry.`}</p>
      <h5 {...{
        "id": "turn-0-33"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Last Chance > Shoot once, Stendhal`}</li>
        <li parentName="ul"><em parentName="li">{`Dodge his stuff.`}</em></li>
        <li parentName="ul">{`Lune: Elemental Trick > Attack`}</li>
        <li parentName="ul">{`Sciel: Intervention Lune`}</li>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
      </ul>
      <p>{`Gradient Parry him destroying the world.`}</p>
    </Battle>
    <p>{`Go to flag.`}</p>
    <Menu timing="Jump down from Osquio battle." mdxType="Menu">
      <h5 {...{
        "id": "formation-14"
      }}>{`Formation`}</h5>
      <p>{`-+Lune`}</p>
    </Menu>
    <Menu timing="At flag" mdxType="Menu">
      <h5 {...{
        "id": "upgrade-resources-2"
      }}>{`Upgrade Resources`}</h5>
      <ul>
        <li parentName="ul">{`Lune: +90 Lumina (225)`}</li>
      </ul>
      <p>{`Back to Continent.`}</p>
    </Menu>
    <h3 {...{
      "id": "continent-16"
    }}>{`Continent`}</h3>
    <p>{`Go to Endless Tower`}</p>
    <h3 {...{
      "id": "endless-tower"
    }}>{`Endless Tower`}</h3>
    <p>{`Fight first 3 floors:`}</p>
    <Battle mdxType="Battle">
      <ol>
        <li parentName="ol">{`1-1: Shoot to death.`}</li>
        <li parentName="ol">{`1-2: Shoot left enemy once, Phantom Strike (0:06)`}</li>
        <li parentName="ol">{`1-3: Last Chance > Shoot once, Phantom Strike (0:12)`}</li>
      </ol>
    </Battle>
    <p>{`Finish upgrading Lune's Lumina if short earlier, and menu.`}</p>
    <Menu timing="Before Clea Unleashed" mdxType="Menu">
      <h5 {...{
        "id": "pictos-37"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Lune:`}<ul parentName="li">
            <li parentName="ul">{`+Gradient Overcharge > Double Third`}</li>
            <li parentName="ul">{`+Burn Affinity > Frenzy`}</li>
          </ul></li>
        <li parentName="ul">{`Maelle:`}<ul parentName="li">
            <li parentName="ul">{`+Greater Defenceless > Solo Fighter`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina-26"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Lune:`}<ul parentName="li">
            <li parentName="ul">{`+Confident Fighter`}</li>
            <li parentName="ul">{`+Double Third`}</li>
            <li parentName="ul">{`+Frenzy`}</li>
            <li parentName="ul">{`+Greater Powerful`}</li>
            <li parentName="ul">{`+Shield Affinity`}</li>
            <li parentName="ul">{`+Shortcut`}</li>
            <li parentName="ul">{`+Warming Up`}</li>
          </ul></li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "clea-unleashed-155"
      }}>{`Clea Unleashed (1:55)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`$252199, 29700000XP, Clea's Death, 20 Lumina, 5 Grandiose, 1 Perfect`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-34"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Egide > Shoot once, Phantom Strike`}</li>
        <li parentName="ul">{`Sciel: All Set > Attack`}</li>
        <li parentName="ul">{`Lune: Elemental Trick > Attack`}</li>
      </ul>
      <p>{`Counter her move.`}</p>
      <h5 {...{
        "id": "turn-1-23"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Guard Down > Shoot once, Phantom Strike`}</li>
        <li parentName="ul">{`Sciel: Fortune Fury Lune > Our Sacrifice`}</li>
        <li parentName="ul">{`Maelle: Last Chance > Shoot once, Stendhal`}</li>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
      </ul>
    </Battle>
    <p><strong parentName="p">{`Chroma Elixer`}</strong>{`. Go to `}<strong parentName="p">{`Chromatic Lampmaster`}</strong>{`.`}</p>
    <Menu timing="Before Chromatic Lampmaster" mdxType="Menu">
      <h5 {...{
        "id": "weapons-10"
      }}>{`Weapons`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Cleim`}</li>
        <li parentName="ul">{`Verso: Sakaram (Anything but Simoso)`}</li>
      </ul>
      <h5 {...{
        "id": "pictos-38"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Maelle:`}<ul parentName="li">
            <li parentName="ul">{`+Confident Fighter > Powerful Mark`}</li>
          </ul></li>
        <li parentName="ul">{`Sciel:`}<ul parentName="li">
            <li parentName="ul">{`+(Traingle) Clea's Death > Second Chance`}</li>
            <li parentName="ul">{`+Auto Death > Trigger Happy`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina-27"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Sciel:`}<ul parentName="li">
            <li parentName="ul">{`(R3) -Inverted Affinity`}</li>
            <li parentName="ul">{`+Second Chance`}</li>
          </ul></li>
        <li parentName="ul">{`Maelle:`}<ul parentName="li">
            <li parentName="ul">{`-Warming Up`}</li>
            <li parentName="ul">{`+Powerful Mark`}</li>
            <li parentName="ul">{`+Frenzy`}</li>
            <li parentName="ul">{`(R3) -At Death's Door`}</li>
            <li parentName="ul">{`-Augmented First Strike`}</li>
            <li parentName="ul">{`-Critical Burn`}</li>
            <li parentName="ul">{`-Critical Moment`}</li>
            <li parentName="ul">{`-Dead Energy II`}</li>
            <li parentName="ul">{`+Double-Third`}</li>
            <li parentName="ul">{`+Energising Turn`}</li>
          </ul></li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "chromatic-lampmaster-233"
      }}>{`Chromatic Lampmaster (2:33)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`$252000, 29700000XP, First Life, 20 Lumina, 5 Grandiose, 1 Perfect`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-35"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Guard Down > Shoot once, Gustave's Homage (Kill #1)`}</li>
        <li parentName="ul">{`Lune: Elemental Trick > Lightning Dance (Kill #2)`}</li>
        <li parentName="ul">{`Sciel: Our Sacrifice > Intervention Maelle`}</li>
        <li parentName="ul">{`Maelle:`}<ol parentName="li">
            <li parentName="ol">{`Shoot once > Stendhal (Kill #3)`}</li>
            <li parentName="ol">{`Last Chance`}</li>
            <li parentName="ol">{`Shoot once > Stendhal (Kill #4)`}</li>
          </ol></li>
        <li parentName="ul">{`Lune: Elemental Trick > Elemental Genesis (Kill #5)`}</li>
      </ul>
    </Battle>
    <p>{`Take jump down and go back to flag and `}<strong parentName="p">{`Rest`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Go to Duolliste.`}</p>
    <Menu timing="Before Duolliste, preferably on jump" mdxType="Menu">
      <h5 {...{
        "id": "weapons-11"
      }}>{`Weapons`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Esquim`}</li>
      </ul>
      <h5 {...{
        "id": "pictos-39"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Lune:`}<ul parentName="li">
            <li parentName="ul">{`+First Life > Gradient Overcharge`}</li>
            <li parentName="ul">{`+Greater Defenceless > Burn Affinity `}<strong parentName="li">{`(Swap)`}</strong></li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina-28"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: `}<ul parentName="li">
            <li parentName="ul">{`+At Death's Door`}</li>
            <li parentName="ul">{`+Critical Burn`}</li>
            <li parentName="ul">{`-Energising Turn`}</li>
            <li parentName="ul">{`-First Strike`}</li>
            <li parentName="ul">{`(R3) +Warming Up`}</li>
            <li parentName="ul">{`+Solo Fighter`}</li>
          </ul></li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "duolliste-049"
      }}>{`Duolliste (0:49)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`$756600, 35675640XP, Duollison, 20 Lumina, 5 Grandiose, 1 Perfect`}</p>
      </blockquote>
      <h4 {...{
        "id": "turn-0-36"
      }}>{`Turn 0`}</h4>
      <ul>
        <li parentName="ul">{`Lune: Elemental Trick > Attack`}</li>
        <li parentName="ul">{`Sciel: Fortune Fury Lune > Our Sacrifice`}</li>
        <li parentName="ul">{`Maelle: Last Chance > shoot one, Stendhal (finish phase 1)`}</li>
      </ul>
      <h4 {...{
        "id": "turn-1-24"
      }}>{`Turn 1`}</h4>
      <ul>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
      </ul>
    </Battle>
    <p><strong parentName="p">{`Chroma Elixer`}</strong>{`. Go to Simon.`}</p>
    <Menu timing="Before Simon" mdxType="Menu">
      <h5 {...{
        "id": "formation-15"
      }}>{`Formation`}</h5>
      <p>{`-Maelle, +Verso, -Lune, -Sciel`}</p>
      <h5 {...{
        "id": "pictos-40"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Sciel:`}<ul parentName="li">
            <li parentName="ul">{`-`}<strong parentName="li">{`Auto Death`}</strong></li>
          </ul></li>
        <li parentName="ul">{`Verso: `}<ul parentName="li">
            <li parentName="ul">{`+Clea's Death`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina-29"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Maelle:`}<ul parentName="li">
            <li parentName="ul">{`-In Media Res (Optional)`}</li>
            <li parentName="ul">{`+First Strike`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "formation-16"
      }}>{`Formation`}</h5>
      <p>{`+Maelle`}</p>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "simon-the-divergent-star-217"
      }}>{`Simon the Divergent Star (2:17)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`$252000, 24750000XP, 20 Lumina, 5 Grandiose, 1 Perfect`}</p>
      </blockquote>
      <p>{`Dodge his first attack. If you get hit, retry.`}</p>
      <h5 {...{
        "id": "turn-0-37"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Shoot twice if he stole shields, Attack`}</li>
        <li parentName="ul">{`Maelle: `}<ol parentName="li">
            <li parentName="ol">{`Healing Tint Verso (he should die)`}</li>
            <li parentName="ol">{`Last Chance`}</li>
            <li parentName="ol">{`Shoot once, Stendhal`}</li>
          </ol></li>
      </ul>
      <p>{`Should remove party and transition to phase 2.`}</p>
      <p>{`The turn order here is random. Monoco always skips, Sciel actions change depending on turn order.`}</p>
      <h5 {...{
        "id": "turn-0-38"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Elemental Trick > Attack > Lightning Dance`}</li>
        <li parentName="ul">{`Sciel: Our Sacrifice > Intervention Lune if before Lune, Attack if after Lune`}</li>
      </ul>
    </Battle>
    <p>{`GG!`}</p>
    <h2 {...{
      "id": "bonus-strats"
    }}>{`Bonus Strats`}</h2>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "fast-dualliste-71106hp-140215"
      }}>{`Fast Dualliste 71106HP (1:40/2:15)`}</h4>
      <p>{`Good or bad fight depends on targetting, bad fight loses ~30s.`}<br parentName="p"></br>{`
`}{`1st phase you really want Sciel or Verso target. 2nd phase you NEED Verso target at the start.`}</p>
      <h5 {...{
        "id": "turn-0-39"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Berserk Slash`}</li>
      </ul>
      <h5 {...{
        "id": "turn-1-25"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Immolation if Verso Target / Energy Tint Verso`}</li>
        <li parentName="ul">{`Verso: Berserk Slash`}</li>
        <li parentName="ul">{`Sciel: Intervention Verso`}</li>
        <li parentName="ul">{`Verso: Defiant Strike / Berserk Slash`}</li>
      </ul>
      <p>{`Phase transitions here. `}<strong parentName="p">{`Notation is good / bad fight`}</strong>{`. Good fight is ONLY if Verso is targeted on his 1st attack.`}<br parentName="p"></br>{`
`}{`If good fight, parry everything. If not, dodge everything, you want to do less than half his HP on this turn.`}</p>
      <h5 {...{
        "id": "turn-2-11"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Tint Sciel if under 5AP or Attack or Immolation / Skip`}</li>
        <li parentName="ul">{`Verso: Berserk Slash`}</li>
        <li parentName="ul">{`Sciel: Intervention Verso > Berserk Slash / Tint if needed, else nothing`}</li>
      </ul>
      <p>{`Good fight kills here.`}</p>
      <h5 {...{
        "id": "turn-3-6"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Attack or Immolation or nothing`}</li>
        <li parentName="ul">{`Verso: Berserk Slash`}</li>
        <li parentName="ul">{`Sciel: Intervention Verso`}</li>
        <li parentName="ul">{`Verso: Berserk Slash`}</li>
      </ul>
    </Menu>
    <h2 {...{
      "id": "archive"
    }}>{`Archive`}</h2>
    <h4 {...{
      "id": "spring-meadows-lanceram-volester-abbest-70xp-216-019"
    }}>{`Spring Meadows Lanceram Volester Abbest 70XP $216 (0:19)`}</h4>
    <h5 {...{
      "id": "turn-0-40"
    }}>{`Turn 0`}</h5>
    <ul>
      <li parentName="ul">{`Gustav`}<ul parentName="li">
          <li parentName="ul">{`Shoot Volester 3 times to kill (main body, hitting weakness does less)`}</li>
          <li parentName="ul">{`Then shoot other weakpoints and attack Lanceram (default)`}</li>
        </ul></li>
      <li parentName="ul">{`Lune: Ice Lance Abbest (default)`}</li>
    </ul>
    <p>{`Parry Lanceram, Abbest dies to burn`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "flying-waters-bruler--cruleram-028"
      }}>{`Flying Waters Bruler & Cruleram (0:28)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`1069XP, $400, 2 Chroma Catalyst?`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-1-26"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Marking Shot Bruler`}</li>
        <li parentName="ul">{`Lune: Wildfire`}</li>
        <li parentName="ul">{`Maelle: Shoot Bruler Weakpoint, Swift Strike Bruler`}</li>
      </ul>
      <p>{`Dodge Cruleram, no need to parry.`}</p>
      <h5 {...{
        "id": "turn-2-12"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Marking Shot Cruleram`}</li>
        <li parentName="ul">{`Lune: Skip`}</li>
        <li parentName="ul">{`Maelle: Percee Cruleram`}</li>
      </ul>
    </Menu>
    <h4 {...{
      "id": "swc-rocher-3367hp-1575xpnb-316-011"
    }}>{`SWC Rocher 3367HP 1575XP(NB) $316 (0:11)`}</h4>
    <ul>
      <li parentName="ul">{`Lune: Wildfire (fail QTE) `}</li>
      <li parentName="ul">{`Gustav: Marking Shot`}</li>
      <li parentName="ul">{`Maelle: Percee`}</li>
    </ul>
    <h2 {...{
      "id": "timings"
    }}>{`Timings`}</h2>
    <h3 {...{
      "id": "spring-meadows-1"
    }}>{`Spring Meadows`}</h3>
    <p>{`The $720 chroma detour takes 11.5s.`}<br parentName="p"></br>{`
`}{`Empowering Attack Picto is ~15s detour after Eveque.`}</p>
    <h3 {...{
      "id": "flying-waters-1"
    }}>{`Flying Waters`}</h3>
    <p>{`The Bruler than jumps down after Manor can be done pretty quick. $466, 1340XP, Bruleram.`}<br parentName="p"></br>{`
`}{`The Bruler + Crueler fight gives 1069XP $400`}<br parentName="p"></br>{`
`}{`Money pickups after tunnel cost ~6.5s for $990`}</p>
    <h3 {...{
      "id": "esquies-nest-1"
    }}>{`Esquie's Nest`}</h3>
    <p>{`Backtracking after Francois is 12s faster, but loses $1305 and Colour of Lumina.`}<br parentName="p"></br>{`
`}{`Flagging after Esquie saves ~13s, but loses Energising Start III.`}</p>
    <h3 {...{
      "id": "visages-1"
    }}>{`Visages`}</h3>
    <p>{`Killing self with Wildfire + Perfect Recovery > Flee: `}{`~`}{`14.5s`}<br parentName="p"></br>{`
`}{`Killing self with Wildfire + Perfect Recovery > 2nd party: `}{`~`}{`21s`}<br parentName="p"></br>{`
`}{`Killing self with 2 Moisonneusse (2 short combo) > `}{`~`}{`34s`}</p>
    <h3 {...{
      "id": "sirene-2"
    }}>{`Sirene`}</h3>
    <p>{`Standard Wildfire Ballet death: 29s`}<br parentName="p"></br>{`
`}{`Enemies before Glissando: 32s`}</p>
    <h3 {...{
      "id": "other"
    }}>{`Other`}</h3>
    <p>{`Upgrading Healing Tint when near curator: 4s`}</p>
    <h2 {...{
      "id": "routing-ideas-to-explore"
    }}>{`Routing Ideas to Explore`}</h2>
    <h2 {...{
      "id": "changelog"
    }}>{`Changelog`}</h2>
    <h5 {...{
      "id": "51426"
    }}>{`5/14/26`}</h5>
    <ul>
      <li parentName="ul">{`Abandon battle Maelle at start`}</li>
      <li parentName="ul">{`Replace Lumina from fight with SWC one after farm`}</li>
    </ul>
    <h5 {...{
      "id": "3326"
    }}>{`3/3/26`}</h5>
    <ul>
      <li parentName="ul">{`Give Gustave & Lune Dodger at Goblu cutscene`}</li>
      <li parentName="ul">{`Don't need to give Verso Dodger before Dualliste (he already has it)`}</li>
      <li parentName="ul">{`Don't give Sciel Scielson for Danseuse farm`}</li>
    </ul>
    <h5 {...{
      "id": "21725"
    }}>{`2/17/25`}</h5>
    <ul>
      <li parentName="ul">{`Give Maelle Burning Mark on Renoir 1`}</li>
      <li parentName="ul">{`Skip Tainted SWC Chroma pickup`}</li>
      <li parentName="ul">{`Equip Augmented First Strike to Maelle start of Act 3 (optional)`}</li>
      <li parentName="ul">{`Updated Verso's Drafts notes to timings I was doing in runs`}</li>
      <li parentName="ul">{`Do Sciel pictos on Waterfall jump, she now gets Slowing Attack too`}</li>
      <li parentName="ul">{`Skip chroma pickup in Verso's Drafts`}</li>
      <li parentName="ul">{`Continent $5840 pickup before Yellow Harvest is now mandatory (notes are unchanged, it was already in here)`}</li>
      <li parentName="ul">{`No longer get Death Bomb`}</li>
      <li parentName="ul">{`No longer buy Lumina in Yellow Harvest `}<strong parentName="li">{`IMPORTANT, will be short money if you do`}</strong>{`.`}</li>
      <li parentName="ul">{`No longer equip Auto Death & Second Chance in Yellow Harvest. Auto Death is no longer learned.`}</li>
      <li parentName="ul">{`WM battle is now killed with Lune shots.`}</li>
      <li parentName="ul">{`Got rid of old Grandiose pickup in Frozen Hearts (was already skipped, forgot to remove earlier)`}</li>
      <li parentName="ul">{`More specific menuing notes leading up to XP farm.`}</li>
      <li parentName="ul">{`Lumina spread is different, post XP farm is 135 Lune, 285 Maelle, 100 Sciel`}</li>
      <li parentName="ul">{`Removed 3 Lumina buy in Sirene, better to buy in Renoir's Drafts`}</li>
      <li parentName="ul">{`Sirene Lumina menu changed slightly`}</li>
      <li parentName="ul">{`Less Lumina bought in Renoir's Drafts, route changes cut 20 Lumina`}</li>
      <li parentName="ul">{`Sciel Lumina is different, gets Feint, Inverted, Beneficial Contamination instead of Energy Master`}</li>
      <li parentName="ul">{`Different lumina menus in Renoir's Drafts jump, Flying Manor`}</li>
      <li parentName="ul">{`Verso no longer gets Auto Death in Verso's Drafts, and is no longer added to the party.`}</li>
      <li parentName="ul">{`Endless Tower 1-1 & 1-2 have different fights now without Death Bomb`}</li>
      <li parentName="ul">{`Menu before Chromatic Lamp is very different.`}</li>
      <li parentName="ul">{`Menu before Duolliste is slightly different.`}</li>
    </ul>
    <h5 {...{
      "id": "21026"
    }}>{`2/10/26`}</h5>
    <ul>
      <li parentName="ul">{`Shoot Simon P1 once for burn for crit burn`}</li>
    </ul>
    <h5 {...{
      "id": "2926"
    }}>{`2/9/26`}</h5>
    <ul>
      <li parentName="ul">{`Move removing Critical Moment from Lune from Endless Tower to Simon jump`}</li>
      <li parentName="ul">{`Add exact damage numbers for Lampmaster`}</li>
      <li parentName="ul">{`Remove Electrify & Thunderfall before Goblu. Let's Storm Caller default to bottom right.`}</li>
    </ul>
    <h5 {...{
      "id": "2726"
    }}>{`2/7/26`}</h5>
    <ul>
      <li parentName="ul">{`Upgrade Bruleram 4 & Lighterim 3 after Flying Waters`}</li>
      <li parentName="ul">{`Don't flag start Ancient Sanctuary. Petank backup uses Ice Lance`}</li>
      <li parentName="ul">{`Rain of Fire Ultimate Sakapatate is now default`}</li>
      <li parentName="ul">{`Added adjustments for Bruleram 4 in tournament`}</li>
      <li parentName="ul">{`Maelle gets Might in Equie's Nest, Gustave Attack Francois is backup to no crit`}</li>
      <li parentName="ul">{`Lighterim upgrade after Esquie's Nest. Added note about bonus Polished & Lighterim 9`}</li>
      <li parentName="ul">{`Added note on Monoco Station setup battle with Scielson 5`}</li>
      <li parentName="ul">{`Slight adjustment of Sirene menu order`}</li>
      <li parentName="ul">{`Added Lune Attack to Paintress P3 if Verso healed`}</li>
      <li parentName="ul">{`Learn different Maelle skills in Dark Shores`}</li>
      <li parentName="ul">{`Cut out Grandiose pickups, buy 5. This was missed in earlier revisions.`}</li>
      <li parentName="ul">{`Upgrade Maelle & Lune stats at end of Verso's Drafts. Needed for Yellow Harvest Maelle merchant kill.`}</li>
      <li parentName="ul">{`Maelle no longer gets Lumina & Teamwork before XP Farm`}</li>
      <li parentName="ul">{`Adjust Lumina counts after XP Farm`}</li>
      <li parentName="ul">{`Different skill slots after XP Farm for Maelle. Biggest change is that Stendhal is Bottom-Left now.`}</li>
      <li parentName="ul">{`Adjusted Picto menu pre-Simon. Same concepts, just faster inputs.`}</li>
      <li parentName="ul">{`Use Percee on Simon P1, Chromatic Goblu, Lamp, Eveque, Dualliste, Licornapieds`}</li>
      <li parentName="ul">{`Flying Manor order changed, Eveques after Goblu, Dualliste last.`}</li>
      <li parentName="ul">{`Flying Manor done solo after Eveques.`}</li>
      <li parentName="ul">{`Different Lumina on Maelle here, biggest change is Augmented First Strike equipped.`}</li>
      <li parentName="ul">{`Use Clea cutscene to change formation & give Sciel Trigger-happy`}</li>
      <li parentName="ul">{`Add note that you can shoot Double-Third fight.`}</li>
      <li parentName="ul">{`Equip Guard Down entering Osquio fight.`}</li>
      <li parentName="ul">{`Fix some mistakes on fight notes for final 4 superbosses.`}</li>
    </ul>
    <h5 {...{
      "id": "2526"
    }}>{`2/5/26`}</h5>
    <ul>
      <li parentName="ul">{`Mostly Act 1 & 2 changes, with the big thing being stat distrutions in Act 2`}</li>
      <li parentName="ul">{`No longer equip DE2 Lumina in Flying Waters`}</li>
      <li parentName="ul">{`Equip DE2 on Verso before Dualliste`}</li>
      <li parentName="ul">{`Lumina menus in Act 2 bit more optimized`}</li>
      <li parentName="ul">{`Different stats for Lune & Sciel in Old Lumiere`}</li>
      <li parentName="ul">{`Monoco uses Augmented First Strike for speed now. Equips it in Old Lumiere cutscene menus.`}</li>
      <li parentName="ul">{`Go to Joy Vale before Sadness Vale now.`}</li>
      <li parentName="ul">{`Pictos & menus changed in Visages`}</li>
      <li parentName="ul">{`Sciel now gets Glass Cannon until Paintress`}</li>
      <li parentName="ul">{`New Mask Keeper fight where Verso is slower than Lune, and it's consistent. Still not the fastest though.`}</li>
      <li parentName="ul">{`Sirene cutscene menu no longer puts ADD on Lune`}</li>
      <li parentName="ul">{`Lune now gets Shield Affinity, Verso re-equips Combo Attack`}</li>
      <li parentName="ul">{`Different stats for all 3 in Sirene`}</li>
      <li parentName="ul">{`You can now dodge Glissando attacks, don't need counter damage.`}</li>
      <li parentName="ul">{`Different Picto menus before Renoir 2 & Paintress`}</li>
      <li parentName="ul">{`Different stat distribution before Renoir 2`}</li>
      <li parentName="ul">{`Now do the fast 2T Renoir 2 strat`}</li>
      <li parentName="ul">{`Skip Chroma Waves counter on Paintress P1`}</li>
      <li parentName="ul">{`No longer equip Shield Affinity on Maelle in Verso's Drafts since it's already learned.`}</li>
      <li parentName="ul">{`XP Farm turn order has changed due to 10 less Agility on Lune. However, it worked out better for us, the fight is now 10-15s faster. Just read notes on when to end fight.`}</li>
    </ul>
    <h5 {...{
      "id": "2426"
    }}>{`2/4/26`}</h5>
    <ul>
      <li parentName="ul">{`Cut Charging Burn`}</li>
      <li parentName="ul">{`Learn Egide for Clea Unleashed`}</li>
      <li parentName="ul">{`Clea Unleashed and menus changed accordingly.`}</li>
    </ul>
    <h5 {...{
      "id": "2326-daylight"
    }}>{`2/3/26 Daylight`}</h5>
    <ul>
      <li parentName="ul">{`Adjusted pre Paintress menu for Lune`}</li>
      <li parentName="ul">{`Added note on how to handle Lune death on Monseiur Frappe`}</li>
      <li parentName="ul">{`DONT remove Crit Moment from Lune before Sprong`}</li>
      <li parentName="ul">{`Fixed missing Beneficial Contamination lumina for Maelle`}</li>
      <li parentName="ul">{`Added missing note to get Charging Burn`}</li>
      <li parentName="ul">{`Optimized Verso Lumina order`}</li>
      <li parentName="ul">{`Clea fight cutscene menu`}</li>
      <li parentName="ul">{`Added note to remove Critical Moment from Maelle before Chromatic Lamp`}</li>
      <li parentName="ul">{`Got rid of unnecessary Trigger-happy to Lune for speed.`}</li>
      <li parentName="ul">{`Fixed Maelle lumina menu before Duolliste`}</li>
    </ul>
    <h5 {...{
      "id": "2326-nighttime"
    }}>{`2/3/26 Nighttime`}</h5>
    <ul>
      <li parentName="ul">{`Flying Waters: Cut Chroma Elixer and Rewarding Mark`}</li>
      <li parentName="ul">{`Flying Waters: Gustave stats changed, he now gets 5 Agility`}</li>
      <li parentName="ul">{`Tainted SWC: Pick up $4260`}</li>
      <li parentName="ul">{`Old Lumiere: No longer do DE2 Chevalier strat. Just Berserk Slash. Keep Maelle's crit stuff longer.`}</li>
      <li parentName="ul">{`Paintress: Equip DE2 on Maelle instead of Critical Moment`}</li>
      <li parentName="ul">{`Added notes to learn Gustave's Homage`}</li>
      <li parentName="ul">{`Dark Shores: Pick up $3848 and $15390`}</li>
      <li parentName="ul">{`Verso's Drafts: Whole new pathing. `}<ul parentName="li">
          <li parentName="ul">{`Cut Alternating Critical`}</li>
          <li parentName="ul">{`Get Gradient Overcharge now`}</li>
          <li parentName="ul">{`Maelle has to survive Feint battle now.`}</li>
          <li parentName="ul">{`Pick up more money / Grandiose`}</li>
          <li parentName="ul">{`Delay Toy Boat submission and Licornapieds Station until revisit.`}</li>
          <li parentName="ul">{`Upgrade Lune's Lumina here now instead of Yellow Harvest`}</li>
        </ul></li>
      <li parentName="ul">{`Continent: On the way to Yellow Harvest pick up $5840`}</li>
      <li parentName="ul">{`Yellow Harvest: Take left path (faster), do menuing on jumps`}</li>
      <li parentName="ul">{`Yellow Harvest: Pick up Death Bomb`}</li>
      <li parentName="ul">{`Yellow Harvest: Add 3 shots to Merchant fight to guarantee kill.`}</li>
      <li parentName="ul">{`Yellow Harvest: Never buy Recoat here now. Delay Recoat if none owned`}</li>
      <li parentName="ul">{`Maelle gets death pictos before Sprong`}</li>
      <li parentName="ul">{`After Sprong go to Falling Leaves, buy Beneficial Contamination (GOAT of the re-route)`}</li>
      <li parentName="ul">{`No longer fight Chromatic Petank`}</li>
      <li parentName="ul">{`Menus start to change here, not going to cover it all in changelog. Just read the notes :)`}</li>
      <li parentName="ul">{`Added extra battle on shore after Grosse Tete just to learn Cheater.`}</li>
      <li parentName="ul">{`Faster Chromatic Veileur fight.`}</li>
      <li parentName="ul">{`Cut 2 Danseuse loops. 2nd party no longer gets to 99 (92 now). This doesn't break anything.`}</li>
      <li parentName="ul">{`Cut Endless Night Sanctuary and 10 Lumina on the way`}</li>
      <li parentName="ul">{`Pick up Charging Burn in Renoir's Drafts`}</li>
      <li parentName="ul">{`Simon no longer requires janky shots to kill`}</li>
      <li parentName="ul">{`Cut The Crows and 5 Lumina on the way`}</li>
      <li parentName="ul">{`Swap order of Flying Manor, Dualliste before Lamp now.`}</li>
      <li parentName="ul">{`No longer use Cheater on Eveques, Maelle Stendhal's one of them.`}</li>
      <li parentName="ul">{`Verso's Drafts revisit: turn in Toy Boat and go to Licornapieds Station now.`}</li>
      <li parentName="ul">{`Get Double Third in Licornapieds Station.`}</li>
      <li parentName="ul">{`No more Sciel In Media Res for Osquio, since she has Second Chance.`}</li>
      <li parentName="ul">{`Maelle and Lune don't need as much Lumina now`}</li>
      <li parentName="ul">{`Clea Unleashed: Fight changed, now use Our Sacrifice to get more Maelle turns. Needed for damage if bad counter damage`}</li>
      <li parentName="ul">{`Lampmaster: Burning Canvas replaced with Stendhal. Lune's first kill uses Lightning Dance instead of Genesis`}</li>
      <li parentName="ul">{`Go and rest at flag after Lampmaster now.`}</li>
      <li parentName="ul">{`Duolliste: new fight that purposely removes Maelle First Strike :)`}</li>
      <li parentName="ul">{`Simon: Verso now gets Clea's Death`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      